export const translationKeys = {
  comboFiltersDoesNotHaveLabel: "combo.filters.does.not.have.label",
  comboFiltersHasLabel: "combo.filters.has.label",
  wedoWedoFamily: "wedo.wedoFamily",
  wedoWedoFamilyPlural: "wedo.wedoFamily.plural",
  wedoSalat: "wedo.salat",
  webViewproducts: "web.viewproducts",
  webTermsNotChecked: "web.terms.not.checked",
  webTerms: "web.terms",
  webSignupMarketing: "web.signup.marketing",
  webSignupExistingaccount: "web.signup.existingaccount",
  webSignUpFailed: "web.sign.up.failed",
  webSeeTerms: "web.see.terms",
  webRestaurantTomorrow: "web.restaurant.tomorrow",
  webRestaurantToday: "web.restaurant.today",
  webRestaurantOpensat: "web.restaurant.opensat",
  webRestaurantOpen: "web.restaurant.open",
  webRestaurantInfo: "web.restaurant.info",
  webRestaurantClosed: "web.restaurant.closed",
  webResetPasswordCta: "web.reset.password.cta",
  webPrivacy: "web.privacy",
  webPreorderSubtitle: "web.preorder.subtitle",
  webPaymentSubtitle: "web.payment.subtitle",
  webPaymentGoogleAppleSubtitle: "web.payment.google.apple.subtitle",
  webPaymentFailed: "web.payment.failed",
  webPaymentCancelingDescription: "web.payment.canceling.description",
  webPaymentCanceling: "web.payment.canceling",
  webPayment: "web.payment",
  webOrderUnderwaySubtitle: "web.order.underway.subtitle",
  webOrderUnderway: "web.order.underway",
  webOrderTotal: "web.order.total",
  webOrderStatusUntilExpectedPickUp: "web.order.status.until.expected.pick.up",
  webOrderStatusTitle: "web.order.status.title",
  webOrderStatusSeeDetails: "web.order.status.see.details",
  webOrderStatusRejectedTitle: "web.order.status.rejected.title",
  webOrderStatusRejectedSubtitle: "web.order.status.rejected.subtitle",
  webOrderStatusPickUpTime: "web.order.status.pick.up.time",
  webOrderStatusOrderIsRejected: "web.order.status.order.is.rejected",
  webOrderStatusHasBeenPickedUp: "web.order.status.has.been.picked.up",
  webOrderStatusExpectedReadyForPickUp:
    "web.order.status.expected.ready.for.pick.up",
  webOrderStatusExpectedDeliveryTime: "web.order.status.expected.delivery.time",
  webOrderStatusEatInReadyTime: "web.order.status.eat.in.ready.time",
  webOrderStatusDefault: "web.order.status.default",
  webOrderReceivedSubtitle: "web.order.received.subtitle",
  webOrderReceivedOrderStatusSubtitle:
    "web.order.received.order.status.subtitle",
  webOrderReceivedInRestaurant: "web.order.received.in.restaurant",
  webOrderReceivedCtatext: "web.order.received.ctatext",
  webOrderReceived: "web.order.received",
  webOrderReadySubtitle: "web.order.ready.subtitle",
  webOrderReadyInRestaurantSubtitle: "web.order.ready.in.restaurant.subtitle",
  webOrderReadyInRestaurant: "web.order.ready.in.restaurant",
  webOrderReady: "web.order.ready",
  webOrderPickedUpSubtitle: "web.order.picked.up.subtitle",
  webOrderPickedUpOrderStatus: "web.order.picked.up.order.status",
  webOrderPickedUp: "web.order.picked.up",
  webOrderExpectedDelivery: "web.order.expected.delivery",
  webOrderEatInDeliveredOrderStatusSubtitle:
    "web.order.eat.in.delivered.order.status.subtitle",
  webOrderEatInDeliveredOrderStatus: "web.order.eat.in.delivered.order.status",
  webOrderDetailsTimeMissing: "web.order.details.time.missing",
  webOrderDetailsOrderType: "web.order.details.order.type",
  webOrderDetailsOrderStatus: "web.order.details.order.status",
  webOrderDetailsOrderId: "web.order.details.order.id",
  webOrderDetailsDeliveryAddressMissing:
    "web.order.details.delivery.address.missing",
  webOrderDetailsDate: "web.order.details.date",
  webOrderDetailsAsapOrPreorderMissing:
    "web.order.details.asap.or.preorder.missing",
  webOrderDeliveredSubtitle: "web.order.delivered.subtitle",
  webOrderDelivered: "web.order.delivered",
  webOrderAndPay: "web.order.and.pay",
  webOrderAcceptedSubtitle: "web.order.accepted.subtitle",
  webOrderAcceptedDeliverySubtitle: "web.order.accepted.delivery.subtitle",
  webOrderAccepted: "web.order.accepted",
  webNotavailable: "web.notavailable",
  webNoLoyaltySubtitle: "web.no.loyalty.subtitle",
  webLoginNoaccount: "web.login.noaccount",
  webLoginFailedLogin: "web.login.failed.login",
  webInputCodePlaceholder: "web.input.code.placeholder",
  webInputCodeLabel: "web.input.code.label",
  webForgotpasswordSubtitle: "web.forgotpassword.subtitle",
  webForgotpasswordButtoncta: "web.forgotpassword.buttoncta",
  webExpectedReadyTimePickupInterval: "web.expected.ready.time.pickup.interval",
  webExpectedReadyTimePickup: "web.expected.ready.time.pickup",
  webExpectedReadyTimeEatIn: "web.expected.ready.time.eatIn",
  webEntercodeUserNotVerified: "web.entercode.user.not.verified",
  webEntercodeUserAlreadyVerified: "web.entercode.user.already.verified",
  webEntercodeOrderAlreadyPlaced: "web.entercode.order.already.placed",
  webEntercodeMaximumExceeded: "web.entercode.maximum.exceeded",
  webEntercodeCodeNotFound: "web.entercode.code.not.found",
  webEntercodeCodeAlreadyUsed: "web.entercode.code.already.used",
  webEanZipPlaceholder: "web.ean.zip.placeholder",
  webEanZip: "web.ean.zip",
  webEanTitle: "web.ean.title",
  webEanPublic: "web.ean.public",
  webEanPrivate: "web.ean.private",
  webEanPay: "web.ean.pay",
  webEanInstitutionNamePlaceholder: "web.ean.institution.name.placeholder",
  webEanInstitutionName: "web.ean.institution.name",
  webEanEanNumberPlaceholder: "web.ean.ean.number.placeholder",
  webEanEanNumber: "web.ean.ean.number",
  webEanCityPlaceholder: "web.ean.city.placeholder",
  webEanCity: "web.ean.city",
  webEanAttentionPlaceholder: "web.ean.attention.placeholder",
  webEanAttention: "web.ean.attention",
  webDeliverymethodWhere: "web.deliverymethod.where",
  webDeliverymethodHow: "web.deliverymethod.how",
  webCreditCardPay: "web.credit.card.pay",
  webCouldNotSaveCard: "web.could.not.save.card",
  webCookiePreferencesTitle: "web.cookie.preferences.title",
  webCookiePreferencesSubtitle: "web.cookie.preferences.subtitle",
  webConfirmCodeCodeUserExists: "web.confirm.code.code.user.exists",
  webConfirmCodeCodeNotFound: "web.confirm.code.code.not.found",
  webChooseTimeInputLabel: "web.choose.time.input.label",
  webChooseLanguage: "web.choose.language",
  webChooseDayInputLabel: "web.choose.day.input.label",
  webChooseDay: "web.choose.day",
  webChoose: "web.choose",
  webCheckoutYourDetails: "web.checkout.your.details",
  webCheckoutSecurelyPayment: "web.checkout.securely.payment",
  webCheckoutPayWithCard: "web.checkout.pay.with.card",
  webCheckoutNoloyalty: "web.checkout.noloyalty",
  webCheckoutMethodTitle: "web.checkout.method.title",
  webCheckoutManagePaymentCards: "web.checkout.manage.payment.cards",
  webCheckoutLoyaltyExplain: "web.checkout.loyalty.explain",
  webCheckoutLoyaltyApplied: "web.checkout.loyalty.applied",
  webCartEmpty: "web.cart.empty",
  webAddressIncomplete: "web.address.incomplete",
  webAddCardFailed: "web.add.card.failed",
  webAddAddressPostcodeMissing: "web.add.address.postcode.missing",
  webAddAddressInstructionsMissing: "web.add.address.instructions.missing",
  webAddAddressCityMissing: "web.add.address.city.missing",
  webAddAddressAddressMissing: "web.add.address.address.missing",
  walletVouchersCtaTitle: "wallet.vouchers.cta.title",
  walletVouchersCtaDescription: "wallet.vouchers.cta.description",
  walletTitleVouchers: "wallet.title.vouchers",
  walletTitleTopUpCards: "wallet.title.topUpCards",
  walletTitleDiscountCards: "wallet.title.discountCards",
  walletTitleCreditCards: "wallet.title.creditCards",
  walletTitleAdd: "wallet.title.add",
  venuedetailsDeliveryStartingPrice: "venuedetails.deliveryStartingPrice",
  venuedetailsDeliveryOptionsPickupDelivery:
    "venuedetails.deliveryOptions.pickupDelivery",
  venuedetailsDeliveryOptionsPickup: "venuedetails.deliveryOptions.pickup",
  venuedetailsDeliveryOptionsEatInChooseTableFooter:
    "venuedetails.deliveryOptions.eatIn.chooseTable.footer",
  venuedetailsDeliveryOptionsEatInChooseTable:
    "venuedetails.deliveryOptions.eatIn.chooseTable",
  venuedetailsDeliveryOptionsEatIn: "venuedetails.deliveryOptions.eatIn",
  venuedetailsDeliveryOptionsDelivery: "venuedetails.deliveryOptions.delivery",
  venuedetailsDeliveryOptionsAnd: "venuedetails.deliveryOptions.and",
  venuedetailsDeliveryMinimumOrder: "venuedetails.deliveryMinimumOrder",
  venuedetailsClosingAt: "venuedetails.closingAt",
  venuedetailsClosed: "venuedetails.closed",
  venueDetailsClosedOpeningSoon: "venueDetails.closedOpeningSoon",
  vatNumber: "vat.number",
  startTitleWefeatorganic: "start.title.wefeatorganic",
  startTitleWefeat: "start.title.wefeat",
  startTitleWedo: "start.title.wedo",
  startTitleTsutsu: "start.title.tsutsu",
  startTitleTheburgerconcept: "start.title.theburgerconcept",
  startTitleSmag: "start.title.smag",
  startTitlePalaeo: "start.title.palaeo",
  startTitleOlioli: "start.title.olioli",
  startTitleMaexico: "start.title.maexico",
  startTitleKunguak: "start.title.kunguak",
  startTitleKcalfactory: "start.title.kcalfactory",
  startTitleJagger: "start.title.jagger",
  startTitleHumblepie: "start.title.humblepie",
  startTitleHubb: "start.title.hubb",
  startTitleGroednorway: "start.title.groednorway",
  startTitleGroed: "start.title.groed",
  startTitleGorms: "start.title.gorms",
  startTitleGarbanzo: "start.title.garbanzo",
  startTitleFrankies: "start.title.frankies",
  startTitleEdenjaxx: "start.title.edenjaxx",
  startTitleCocorico: "start.title.cocorico",
  startTitleCaspers: "start.title.caspers",
  startTitleBuzzcph: "start.title.buzzcph",
  startTitleBurgerbeast: "start.title.burgerbeast",
  startTitleBuns: "start.title.buns",
  startTitleBoff: "start.title.boff",
  startTitleBlokksmash: "start.title.blokksmash",
  startTitleBiteline: "start.title.biteline",
  startTitleBindia: "start.title.bindia",
  startTitleAmanogroup: "start.title.amanogroup",
  startTitleWaldorfGroup: "start.title.Waldorf.Group",
  startTitleTommis: "start.title.Tommis",
  startTitleTheFatGreek: "start.title.TheFatGreek",
  startTitleStrangas: "start.title.Strangas",
  startTitleStacys: "start.title.Stacys",
  startTitleShabaz: "start.title.Shabaz",
  startTitleSandwichpigen: "start.title.Sandwichpigen",
  startTitleSURTX: "start.title.SURT2",
  startTitleRollneat: "start.title.Rollneat",
  startTitleRaSushi: "start.title.RaSushi",
  startTitlePureGreensClub: "start.title.PureGreensClub",
  startTitlePicopizza: "start.title.Picopizza",
  startTitleParadis: "start.title.Paradis",
  startTitlePanzanella: "start.title.Panzanella",
  startTitlePHAGO: "start.title.PHAGO",
  startTitleOAKBERRY: "start.title.OAKBERRY",
  startTitleNOAHS: "start.title.NOAHS",
  startTitleMubanthai: "start.title.Mubanthai",
  startTitleMaikai: "start.title.Maikai",
  startTitleMadklubben: "start.title.Madklubben",
  startTitleMaMeMi: "start.title.MaMeMi",
  startTitleLighthouseburger: "start.title.Lighthouseburger",
  startTitleLetzsushi: "start.title.Letzsushi",
  startTitleKyllingCo: "start.title.KyllingCo",
  startTitleKillerkebab: "start.title.Killerkebab",
  startTitleIscafeen: "start.title.Iscafeen",
  startTitleIRONWOK: "start.title.IRONWOK",
  startTitleIKISUSHI: "start.title.IKISUSHI",
  startTitleHellopasta: "start.title.Hellopasta",
  startTitleGoldenroost: "start.title.Goldenroost",
  startTitleGeppetto: "start.title.Geppetto",
  startTitleGaodumpling: "start.title.Gaodumpling",
  startTitleFrederiksbergSmørrebrød: "start.title.Frederiksberg.Smørrebrød",
  startTitleFlyChicken: "start.title.FlyChicken",
  startTitleEvald: "start.title.Evald",
  startTitleDistrictTonkin: "start.title.DistrictTonkin",
  startTitleDiamondSlice: "start.title.DiamondSlice",
  startTitleDhaba: "start.title.Dhaba",
  startTitleDandelion: "start.title.Dandelion",
  startTitleChavez: "start.title.Chavez",
  startTitleBurgerShack: "start.title.BurgerShack",
  startTitleBuka: "start.title.Buka",
  startTitleBaryl: "start.title.Baryl",
  startTitleBanhBanh: "start.title.BanhBanh",
  startTitleBONES: "start.title.BONES",
  startTitleBADSHA: "start.title.BADSHA",
  startTitleANOTHERPIZZA: "start.title.ANOTHERPIZZA",
  startSneakPeek: "start.sneakPeek",
  startLoginHighlight: "start.loginHighlight",
  startLogin: "start.login",
  startDescriptionWefeatorganic: "start.description.wefeatorganic",
  startDescriptionWefeat: "start.description.wefeat",
  startDescriptionWedo: "start.description.wedo",
  startDescriptionTsutsu: "start.description.tsutsu",
  startDescriptionTheburgerconcept: "start.description.theburgerconcept",
  startDescriptionSmag: "start.description.smag",
  startDescriptionPalaeo: "start.description.palaeo",
  startDescriptionOlioli: "start.description.olioli",
  startDescriptionMaexico: "start.description.maexico",
  startDescriptionKunguak: "start.description.kunguak",
  startDescriptionKcalfactory: "start.description.kcalfactory",
  startDescriptionJagger: "start.description.jagger",
  startDescriptionHumblepie: "start.description.humblepie",
  startDescriptionHubb: "start.description.hubb",
  startDescriptionGroednorway: "start.description.groednorway",
  startDescriptionGroed: "start.description.groed",
  startDescriptionGorms: "start.description.gorms",
  startDescriptionGarbanzo: "start.description.garbanzo",
  startDescriptionFrankies: "start.description.frankies",
  startDescriptionEdenjaxx: "start.description.edenjaxx",
  startDescriptionCocorico: "start.description.cocorico",
  startDescriptionCaspers: "start.description.caspers",
  startDescriptionBuzzcph: "start.description.buzzcph",
  startDescriptionBurgerbeast: "start.description.burgerbeast",
  startDescriptionBuns: "start.description.buns",
  startDescriptionBoff: "start.description.boff",
  startDescriptionBlokksmash: "start.description.blokksmash",
  startDescriptionBiteline: "start.description.biteline",
  startDescriptionBindia: "start.description.bindia",
  startDescriptionAmanogroup: "start.description.amanogroup",
  startDescriptionWaldorfGroup: "start.description.Waldorf.Group",
  startDescriptionTommis: "start.description.Tommis",
  startDescriptionTheFatGreek: "start.description.TheFatGreek",
  startDescriptionStrangas: "start.description.Strangas",
  startDescriptionStacys: "start.description.Stacys",
  startDescriptionShabaz: "start.description.Shabaz",
  startDescriptionSandwichpigen: "start.description.Sandwichpigen",
  startDescriptionSURTX: "start.description.SURT2",
  startDescriptionRollneat: "start.description.Rollneat",
  startDescriptionRaSushi: "start.description.RaSushi",
  startDescriptionPureGreensClub: "start.description.PureGreensClub",
  startDescriptionPicopizza: "start.description.Picopizza",
  startDescriptionParadis: "start.description.Paradis",
  startDescriptionPanzanella: "start.description.Panzanella",
  startDescriptionPHAGO: "start.description.PHAGO",
  startDescriptionOAKBERRY: "start.description.OAKBERRY",
  startDescriptionNOAHS: "start.description.NOAHS",
  startDescriptionMubanthai: "start.description.Mubanthai",
  startDescriptionMaikai: "start.description.Maikai",
  startDescriptionMadklubben: "start.description.Madklubben",
  startDescriptionMaMeMi: "start.description.MaMeMi",
  startDescriptionLighthouseburger: "start.description.Lighthouseburger",
  startDescriptionLetzsushi: "start.description.Letzsushi",
  startDescriptionKyllingCo: "start.description.KyllingCo",
  startDescriptionKillerkebab: "start.description.Killerkebab",
  startDescriptionIscafeen: "start.description.Iscafeen",
  startDescriptionIRONWOK: "start.description.IRONWOK",
  startDescriptionIKISUSHI: "start.description.IKISUSHI",
  startDescriptionHellopasta: "start.description.Hellopasta",
  startDescriptionGoldenroost: "start.description.Goldenroost",
  startDescriptionGeppetto: "start.description.Geppetto",
  startDescriptionGaodumpling: "start.description.Gaodumpling",
  startDescriptionFrederiksbergSmørrebrød:
    "start.description.Frederiksberg.Smørrebrød",
  startDescriptionFlyChicken: "start.description.FlyChicken",
  startDescriptionEvald: "start.description.Evald",
  startDescriptionDistrictTonkin: "start.description.DistrictTonkin",
  startDescriptionDiamondSlice: "start.description.DiamondSlice",
  startDescriptionDhaba: "start.description.Dhaba",
  startDescriptionDandelion: "start.description.Dandelion",
  startDescriptionChavez: "start.description.Chavez",
  startDescriptionBurgerShack: "start.description.BurgerShack",
  startDescriptionBuka: "start.description.Buka",
  startDescriptionBaryl: "start.description.Baryl",
  startDescriptionBanhBanh: "start.description.BanhBanh",
  startDescriptionBONES: "start.description.BONES",
  startDescriptionBADSHA: "start.description.BADSHA",
  startDescriptionANOTHERPIZZA: "start.description.ANOTHERPIZZA",
  startCreateProfile: "start.createProfile",
  referralCtaTitleWefeatorganic: "referral.cta.title.wefeatorganic",
  referralCtaTitleWefeat: "referral.cta.title.wefeat",
  referralCtaTitleWedo: "referral.cta.title.wedo",
  referralCtaTitleTsutsu: "referral.cta.title.tsutsu",
  referralCtaTitleTheburgerconcept: "referral.cta.title.theburgerconcept",
  referralCtaTitleSmag: "referral.cta.title.smag",
  referralCtaTitlePalaeo: "referral.cta.title.palaeo",
  referralCtaTitleOlioli: "referral.cta.title.olioli",
  referralCtaTitleMaexico: "referral.cta.title.maexico",
  referralCtaTitleKcalfactory: "referral.cta.title.kcalfactory",
  referralCtaTitleJagger: "referral.cta.title.jagger",
  referralCtaTitleHumblepie: "referral.cta.title.humblepie",
  referralCtaTitleHubb: "referral.cta.title.hubb",
  referralCtaTitleGroed: "referral.cta.title.groed",
  referralCtaTitleGorms: "referral.cta.title.gorms",
  referralCtaTitleGarbanzo: "referral.cta.title.garbanzo",
  referralCtaTitleFrankies: "referral.cta.title.frankies",
  referralCtaTitleEdenjaxx: "referral.cta.title.edenjaxx",
  referralCtaTitleCocorico: "referral.cta.title.cocorico",
  referralCtaTitleCaspers: "referral.cta.title.caspers",
  referralCtaTitleBuzzcph: "referral.cta.title.buzzcph",
  referralCtaTitleBurgerbeast: "referral.cta.title.burgerbeast",
  referralCtaTitleBuns: "referral.cta.title.buns",
  referralCtaTitleBoff: "referral.cta.title.boff",
  referralCtaTitleBlokksmash: "referral.cta.title.blokksmash",
  referralCtaTitleBiteline: "referral.cta.title.biteline",
  referralCtaTitleBindia: "referral.cta.title.bindia",
  referralCtaTitleAmanogroup: "referral.cta.title.amanogroup",
  referralCtaTitleWaldorfGroup: "referral.cta.title.Waldorf.Group",
  referralCtaTitleTheFatGreek: "referral.cta.title.TheFatGreek",
  referralCtaTitleStrangas: "referral.cta.title.Strangas",
  referralCtaTitleStacys: "referral.cta.title.Stacys",
  referralCtaTitleShabaz: "referral.cta.title.Shabaz",
  referralCtaTitleSandwichpigen: "referral.cta.title.Sandwichpigen",
  referralCtaTitleSURTX: "referral.cta.title.SURT2",
  referralCtaTitleRollneat: "referral.cta.title.Rollneat",
  referralCtaTitleRaSushi: "referral.cta.title.RaSushi",
  referralCtaTitlePicopizza: "referral.cta.title.Picopizza",
  referralCtaTitleParadis: "referral.cta.title.Paradis",
  referralCtaTitleOAKBERRY: "referral.cta.title.OAKBERRY",
  referralCtaTitleNOAHS: "referral.cta.title.NOAHS",
  referralCtaTitleMubanthai: "referral.cta.title.Mubanthai",
  referralCtaTitleMadklubben: "referral.cta.title.Madklubben",
  referralCtaTitleMaMeMi: "referral.cta.title.MaMeMi",
  referralCtaTitleLighthouseburger: "referral.cta.title.Lighthouseburger",
  referralCtaTitleLetzsushi: "referral.cta.title.Letzsushi",
  referralCtaTitleKyllingCo: "referral.cta.title.KyllingCo",
  referralCtaTitleKillerkebab: "referral.cta.title.Killerkebab",
  referralCtaTitleIscafeen: "referral.cta.title.Iscafeen",
  referralCtaTitleIRONWOK: "referral.cta.title.IRONWOK",
  referralCtaTitleIKISUSHI: "referral.cta.title.IKISUSHI",
  referralCtaTitleHellopasta: "referral.cta.title.Hellopasta",
  referralCtaTitleGoldenroost: "referral.cta.title.Goldenroost",
  referralCtaTitleGeppetto: "referral.cta.title.Geppetto",
  referralCtaTitleGaodumpling: "referral.cta.title.Gaodumpling",
  referralCtaTitleFrederiksbergSmørrebrød:
    "referral.cta.title.Frederiksberg.Smørrebrød",
  referralCtaTitleDistrictTonkin: "referral.cta.title.DistrictTonkin",
  referralCtaTitleDiamondSlice: "referral.cta.title.DiamondSlice",
  referralCtaTitleDhaba: "referral.cta.title.Dhaba",
  referralCtaTitleDandelion: "referral.cta.title.Dandelion",
  referralCtaTitleChavez: "referral.cta.title.Chavez",
  referralCtaTitleBurgerShack: "referral.cta.title.BurgerShack",
  referralCtaTitleBaryl: "referral.cta.title.Baryl",
  referralCtaTitleBanhBanh: "referral.cta.title.BanhBanh",
  referralCtaTitleBONES: "referral.cta.title.BONES",
  referralCtaTitleBADSHA: "referral.cta.title.BADSHA",
  referralCtaTitleANOTHERPIZZA: "referral.cta.title.ANOTHERPIZZA",
  referralCtaMessageWefeat: "referral.cta.message.wefeat",
  referralCtaMessagePalaeo: "referral.cta.message.palaeo",
  referralCtaMessageKcalfactory: "referral.cta.message.kcalfactory",
  referralCtaMessageJagger: "referral.cta.message.jagger",
  referralCtaMessageGarbanzo: "referral.cta.message.garbanzo",
  referralCtaMessageBuzzcph: "referral.cta.message.buzzcph",
  referralCtaActionWefeatorganic: "referral.cta.action.wefeatorganic",
  referralCtaActionTsutsu: "referral.cta.action.tsutsu",
  referralCtaActionTheburgerconcept: "referral.cta.action.theburgerconcept",
  referralCtaActionSmag: "referral.cta.action.smag",
  referralCtaActionMaexico: "referral.cta.action.maexico",
  referralCtaActionJagger: "referral.cta.action.jagger",
  referralCtaActionHumblepie: "referral.cta.action.humblepie",
  referralCtaActionHubb: "referral.cta.action.hubb",
  referralCtaActionGorms: "referral.cta.action.gorms",
  referralCtaActionFrankies: "referral.cta.action.frankies",
  referralCtaActionEdenjaxx: "referral.cta.action.edenjaxx",
  referralCtaActionCocorico: "referral.cta.action.cocorico",
  referralCtaActionCaspers: "referral.cta.action.caspers",
  referralCtaActionBuzzcph: "referral.cta.action.buzzcph",
  referralCtaActionBurgerbeast: "referral.cta.action.burgerbeast",
  referralCtaActionBuns: "referral.cta.action.buns",
  referralCtaActionBoff: "referral.cta.action.boff",
  referralCtaActionBlokksmash: "referral.cta.action.blokksmash",
  referralCtaActionBiteline: "referral.cta.action.biteline",
  referralCtaActionBindia: "referral.cta.action.bindia",
  referralCtaActionAmanogroup: "referral.cta.action.amanogroup",
  referralCtaActionWaldorfGroup: "referral.cta.action.Waldorf.Group",
  referralCtaActionTommis: "referral.cta.action.Tommis",
  referralCtaActionTheFatGreek: "referral.cta.action.TheFatGreek",
  referralCtaActionStrangas: "referral.cta.action.Strangas",
  referralCtaActionStacys: "referral.cta.action.Stacys",
  referralCtaActionShabaz: "referral.cta.action.Shabaz",
  referralCtaActionSandwichpigen: "referral.cta.action.Sandwichpigen",
  referralCtaActionSURTX: "referral.cta.action.SURT2",
  referralCtaActionRollneat: "referral.cta.action.Rollneat",
  referralCtaActionRaSushi: "referral.cta.action.RaSushi",
  referralCtaActionPureGreensClub: "referral.cta.action.PureGreensClub",
  referralCtaActionParadis: "referral.cta.action.Paradis",
  referralCtaActionPanzanella: "referral.cta.action.Panzanella",
  referralCtaActionPHAGO: "referral.cta.action.PHAGO",
  referralCtaActionOAKBERRY: "referral.cta.action.OAKBERRY",
  referralCtaActionNOAHS: "referral.cta.action.NOAHS",
  referralCtaActionMubanthai: "referral.cta.action.Mubanthai",
  referralCtaActionMaikai: "referral.cta.action.Maikai",
  referralCtaActionMadklubben: "referral.cta.action.Madklubben",
  referralCtaActionMaMeMi: "referral.cta.action.MaMeMi",
  referralCtaActionLighthouseburger: "referral.cta.action.Lighthouseburger",
  referralCtaActionLetzsushi: "referral.cta.action.Letzsushi",
  referralCtaActionKyllingCo: "referral.cta.action.KyllingCo",
  referralCtaActionKillerkebab: "referral.cta.action.Killerkebab",
  referralCtaActionIscafeen: "referral.cta.action.Iscafeen",
  referralCtaActionIRONWOK: "referral.cta.action.IRONWOK",
  referralCtaActionIKISUSHI: "referral.cta.action.IKISUSHI",
  referralCtaActionHelleopasta: "referral.cta.action.Helleopasta",
  referralCtaActionGoldenroost: "referral.cta.action.Goldenroost",
  referralCtaActionGeppetto: "referral.cta.action.Geppetto",
  referralCtaActionGaodumpling: "referral.cta.action.Gaodumpling",
  referralCtaActionFrederiksbergSmørrebrød:
    "referral.cta.action.Frederiksberg.Smørrebrød",
  referralCtaActionFlyChicken: "referral.cta.action.FlyChicken",
  referralCtaActionEvald: "referral.cta.action.Evald",
  referralCtaActionDistrictTonkin: "referral.cta.action.DistrictTonkin",
  referralCtaActionDiamondSlice: "referral.cta.action.DiamondSlice",
  referralCtaActionDhaba: "referral.cta.action.Dhaba",
  referralCtaActionDandelion: "referral.cta.action.Dandelion",
  referralCtaActionChavez: "referral.cta.action.Chavez",
  referralCtaActionBurgerShack: "referral.cta.action.BurgerShack",
  referralCtaActionBaryl: "referral.cta.action.Baryl",
  referralCtaActionBanhBanh: "referral.cta.action.BanhBanh",
  referralCtaActionBONES: "referral.cta.action.BONES",
  referralCtaActionBADSHA: "referral.cta.action.BADSHA",
  referralCtaActionANOTHERPIZZA: "referral.cta.action.ANOTHERPIZZA",
  referralCtaAction: "referral.cta.action",
  promptAddAddressTitle: "prompt.add.address.title",
  promptAddAddressSubtitle: "prompt.add.address.subtitle",
  profileAnonymizeReqestTitle: "profile.anonymizeReqest.title",
  profileAnonymizeReqestProceed: "profile.anonymizeReqest.proceed",
  profileAnonymizeReqestCancel: "profile.anonymizeReqest.cancel",
  profileAnonymizeReqestBody: "profile.anonymizeReqest.body",
  popupDeliverymethodTitle: "popup.deliverymethod.title",
  popUpDeliverymethodSubtitle: "pop.up.deliverymethod.subtitle",
  paymentTimedOut: "payment.timed.out",
  paymentComboTimoutCtaTitle: "payment.combo.timout.cta.title",
  orderToTableCtaAreYouAtRestaurant: "orderToTable.cta.areYouAtRestaurant",
  nightpayReferralOverviewRegistrationsTitle:
    "nightpay.referralOverview.registrationsTitle",
  nightpayReferralOverviewNumberOfFriends:
    "nightpay.referralOverview.numberOfFriends",
  nightpayReferralOverviewInviteCode: "nightpay.referralOverview.inviteCode",
  nightpayReferralApplyErrorNotValid: "nightpay.referralApplyError.notValid",
  nightpayReferralApplyErrorNotFound: "nightpay.referralApplyError.notFound",
  nightpayReferralApplyErrorNotEligible:
    "nightpay.referralApplyError.notEligible",
  nightpayReferralApplyErrorNotActive: "nightpay.referralApplyError.notActive",
  nightpayReferralApplyErrorMaxReached:
    "nightpay.referralApplyError.maxReached",
  nightpayReferralApplyErrorEmpty: "nightpay.referralApplyError.empty",
  nightpayReferralApplyErrorAlreadyUsed:
    "nightpay.referralApplyError.alreadyUsed",
  nightpayProfileRegisterBeaconSuccessTitle:
    "nightpay.profile.registerBeacon.success.title",
  nightpayPaymentHistoryWithdrawal: "nightpay.paymentHistory.withdrawal",
  nightpayPaymentHistoryTripleUpAccount:
    "nightpay.paymentHistory.tripleUpAccount",
  nightpayPaymentHistoryTicketsSpenta: "nightpay.paymentHistory.ticketsSpenta",
  nightpayPaymentHistoryTicketsSpentaPlural:
    "nightpay.paymentHistory.ticketsSpenta.plural",
  nightpayPaymentHistorySubscription: "nightpay.paymentHistory.subscription",
  nightpayPaymentHistoryNotAvailable: "nightpay.paymentHistory.notAvailable",
  nightpayPaymentHistoryDepositAccount:
    "nightpay.paymentHistory.depositAccount",
  nightpayPaymentHistoryDeposit: "nightpay.paymentHistory.deposit",
  nightpayPaymentHistoryCreditCard: "nightpay.paymentHistory.creditCard",
  nightpayPaymentHistoryCampaignBonus: "nightpay.paymentHistory.campaignBonus",
  nightpayPaymentTitleText: "nightpay.payment.titleText",
  nightpayMembershipInviteCode: "nightpay.membership.inviteCode",
  nightpayBenefitsSynchronizing: "nightpay.benefits.synchronizing",
  nextAvailableTime: "next.available.time",
  newAdditionsSingle: "new.additions.single",
  newAdditionsSinglePlural: "new.additions.single.plural",
  newAdditionsMultiZeroToMany: "new.additions.multi.zero.to.many",
  newAdditionsMultiManyToMany: "new.additions.multi.many.to.many",
  newAdditionsMinNotSatisfied: "new.additions.min.not.satisfied",
  newAdditionsMaxReached: "new.additions.max.reached",
  newAdditionsMaxNotSatisfied: "new.additions.max.not.satisfied",
  networkLossSubtitle: "network.loss.subtitle",
  networkLossRefresh: "network.loss.refresh",
  networkLossHeader: "network.loss.header",
  missingTablePromptTitle: "missing.table.prompt.title",
  missingTablePromptSubtitle: "missing.table.prompt.subtitle",
  missingAddressPromptTitle: "missing.address.prompt.title",
  missingAddressPromptSubtitle: "missing.address.prompt.subtitle",
  inputZipNotValid: "input.zip.not.valid",
  inputTermsNotChecked: "input.terms.not.checked",
  inputRequired: "input.required",
  inputPhonenumberNotValid: "input.phonenumber.not.valid",
  inputPhonenumberNoInput: "input.phonenumber.no.input",
  inputPasswordNoInput: "input.password.no.input",
  inputPasswordErrorMessage: "input.password.error.message",
  inputOptional: "input.optional",
  inputLastNameErrorMessage: "input.last.name.error.message",
  inputFirstNameErrorMessage: "input.first.name.error.message",
  inputEmailNoInput: "input.email.no.input",
  inputEmailErrorMessage: "input.email.error.message",
  inputEannumberNotValid: "input.eannumber.not.valid",
  inputEannumberNoInput: "input.eannumber.no.input",
  inputConfirmCodeNotNumber: "input.confirm.code.not.number",
  inputConfirmCodeEnterValue: "input.confirm.code.enter.value",
  inputCommentPlaceholder: "input.comment.placeholder",
  inputCommentLabel: "input.comment.label",
  homeTitle: "home.title",
  homeSectionTitleVouchers: "home.section.title.vouchers",
  homeSectionTitleRewards: "home.section.title.rewards",
  homeSectionTitleOffers: "home.section.title.offers",
  homeSectionTitleNews: "home.section.title.news",
  homeSectionTitleInvite: "home.section.title.invite",
  homeCtaGetDiscountCardTitleWedo: "home.cta.getDiscountCard.title.wedo",
  homeCtaGetDiscountCardTitlePalaeo: "home.cta.getDiscountCard.title.palaeo",
  homeCtaGetDiscountCardTitleOlioli: "home.cta.getDiscountCard.title.olioli",
  homeCtaGetDiscountCardTitleMamemi: "home.cta.getDiscountCard.title.mamemi",
  homeCtaGetDiscountCardTitleMaexico: "home.cta.getDiscountCard.title.maexico",
  homeCtaGetDiscountCardTitleKcalfactory:
    "home.cta.getDiscountCard.title.kcalfactory",
  homeCtaGetDiscountCardTitleJagger: "home.cta.getDiscountCard.title.jagger",
  homeCtaGetDiscountCardTitleHubb: "home.cta.getDiscountCard.title.hubb",
  homeCtaGetDiscountCardTitleGroed: "home.cta.getDiscountCard.title.groed",
  homeCtaGetDiscountCardTitleGorms: "home.cta.getDiscountCard.title.gorms",
  homeCtaGetDiscountCardTitleFrankies:
    "home.cta.getDiscountCard.title.frankies",
  homeCtaGetDiscountCardTitleDistrictTonkin:
    "home.cta.getDiscountCard.title.districtTonkin",
  homeCtaGetDiscountCardTitleCocorico:
    "home.cta.getDiscountCard.title.cocorico",
  homeCtaGetDiscountCardTitleRaSushi: "home.cta.getDiscountCard.title.RaSushi",
  homeCtaGetDiscountCardDescriptionWedo:
    "home.cta.getDiscountCard.description.wedo",
  homeCtaGetDiscountCardDescriptionPalaeo:
    "home.cta.getDiscountCard.description.palaeo",
  homeCtaGetDiscountCardDescriptionOlioli:
    "home.cta.getDiscountCard.description.olioli",
  homeCtaGetDiscountCardDescriptionMamemi:
    "home.cta.getDiscountCard.description.mamemi",
  homeCtaGetDiscountCardDescriptionMaexico:
    "home.cta.getDiscountCard.description.maexico",
  homeCtaGetDiscountCardDescriptionKcalfactory:
    "home.cta.getDiscountCard.description.kcalfactory",
  homeCtaGetDiscountCardDescriptionJagger:
    "home.cta.getDiscountCard.description.jagger",
  homeCtaGetDiscountCardDescriptionHubb:
    "home.cta.getDiscountCard.description.hubb",
  homeCtaGetDiscountCardDescriptionGroed:
    "home.cta.getDiscountCard.description.groed",
  homeCtaGetDiscountCardDescriptionGorms:
    "home.cta.getDiscountCard.description.gorms",
  homeCtaGetDiscountCardDescriptionFrankies:
    "home.cta.getDiscountCard.description.frankies",
  homeCtaGetDiscountCardDescriptionDistrictTonkin:
    "home.cta.getDiscountCard.description.districtTonkin",
  homeCtaGetDiscountCardDescriptionCocorico:
    "home.cta.getDiscountCard.description.cocorico",
  homeCtaGetDiscountCardDescriptionRaSushi:
    "home.cta.getDiscountCard.description.RaSushi",
  homeCtaGetDiscountCard: "home.cta.getDiscountCard",
  homeCtaGamesCardTitle: "home.cta.games.cardTitle",
  homeCtaBuyVouchersTitleWefeat: "home.cta.buyVouchers.title.wefeat",
  homeCtaBuyVouchersTitleWedo: "home.cta.buyVouchers.title.wedo",
  homeCtaBuyVouchersTitleSmag: "home.cta.buyVouchers.title.smag",
  homeCtaBuyVouchersTitlePuregreensclub:
    "home.cta.buyVouchers.title.puregreensclub",
  homeCtaBuyVouchersTitleOlioli: "home.cta.buyVouchers.title.olioli",
  homeCtaBuyVouchersTitleKunguak: "home.cta.buyVouchers.title.kunguak",
  homeCtaBuyVouchersTitleKcal: "home.cta.buyVouchers.title.kcal",
  homeCtaBuyVouchersTitleJagger: "home.cta.buyVouchers.title.jagger",
  homeCtaBuyVouchersTitleHubb: "home.cta.buyVouchers.title.hubb",
  homeCtaBuyVouchersTitleGroed: "home.cta.buyVouchers.title.groed",
  homeCtaBuyVouchersTitleFrankies: "home.cta.buyVouchers.title.frankies",
  homeCtaBuyVouchersTitleEdenjaxx: "home.cta.buyVouchers.title.edenjaxx",
  homeCtaBuyVouchersTitleTommis: "home.cta.buyVouchers.title.Tommis",
  homeCtaBuyVouchersTitlePanzanella: "home.cta.buyVouchers.title.Panzanella",
  homeCtaBuyVouchersTitleMaikai: "home.cta.buyVouchers.title.Maikai",
  homeCtaBuyVouchersTitleKyllingCo: "home.cta.buyVouchers.title.KyllingCo",
  homeCtaBuyVouchersTitleFlyChicken: "home.cta.buyVouchers.title.FlyChicken",
  homeCtaBuyVouchersTitleEvald: "home.cta.buyVouchers.title.Evald",
  homeCtaBuyVouchersDescriptionWefeat:
    "home.cta.buyVouchers.description.wefeat",
  homeCtaBuyVouchersDescriptionWedo: "home.cta.buyVouchers.description.wedo",
  homeCtaBuyVouchersDescriptionSmag: "home.cta.buyVouchers.description.smag",
  homeCtaBuyVouchersDescriptionPuregreensclub:
    "home.cta.buyVouchers.description.puregreensclub",
  homeCtaBuyVouchersDescriptionOlioli:
    "home.cta.buyVouchers.description.olioli",
  homeCtaBuyVouchersDescriptionKunguak:
    "home.cta.buyVouchers.description.kunguak",
  homeCtaBuyVouchersDescriptionKcal: "home.cta.buyVouchers.description.kcal",
  homeCtaBuyVouchersDescriptionJagger:
    "home.cta.buyVouchers.description.jagger",
  homeCtaBuyVouchersDescriptionHubb: "home.cta.buyVouchers.description.hubb",
  homeCtaBuyVouchersDescriptionGroed: "home.cta.buyVouchers.description.groed",
  homeCtaBuyVouchersDescriptionFrankies:
    "home.cta.buyVouchers.description.frankies",
  homeCtaBuyVouchersDescriptionEdenjaxx:
    "home.cta.buyVouchers.description.edenjaxx",
  homeCtaBuyVouchersDescriptionTommis:
    "home.cta.buyVouchers.description.Tommis",
  homeCtaBuyVouchersDescriptionPanzanella:
    "home.cta.buyVouchers.description.Panzanella",
  homeCtaBuyVouchersDescriptionMaikai:
    "home.cta.buyVouchers.description.Maikai",
  homeCtaBuyVouchersDescriptionKyllingCo:
    "home.cta.buyVouchers.description.KyllingCo",
  homeCtaBuyVouchersDescriptionFlyChicken:
    "home.cta.buyVouchers.description.FlyChicken",
  homeCtaBuyVouchersDescriptionEvald: "home.cta.buyVouchers.description.Evald",
  homeCtaBuyVouchersDescription: "home.cta.buyVouchers.description",
  homeCtaBookTableRestaurantPickerTitle:
    "home.cta.bookTable.restaurantPickerTitle",
  homeCtaBookTableCardTitle: "home.cta.bookTable.cardTitle",
  homeBrandsSectionHeader: "home.brands.sectionHeader",
  homeBrandsExploreAll: "home.brands.exploreAll",
  homeBookTable: "home.bookTable",
  homeActionOrderTakeAway: "home.action.orderTakeAway",
  homeAction: "home.action",
  heapsgoVenuedetailsOpensAtTomorrow: "heapsgo.venuedetails.opensAtTomorrow",
  heapsgoVenuedetailsOpensAtToday: "heapsgo.venuedetails.opensAtToday",
  heapsgoVenuedetailsOpensAtDay: "heapsgo.venuedetails.opensAtDay",
  heapsgoVenueMenuQuantity: "heapsgo.venue.menu.quantity",
  heapsgoVenueAway: "heapsgo.venue.away",
  heapsgoTableBookingVenueListTitle: "heapsgo.tableBooking.venueList.title",
  heapsgoTableBookingVenueListMessage: "heapsgo.tableBooking.venueList.message",
  heapsgoReferralOverviewTitle: "heapsgo.referralOverview.title",
  heapsgoReferralOverviewTicketTitleWefeatorganic:
    "heapsgo.referralOverview.ticketTitle.wefeatorganic",
  heapsgoReferralOverviewTicketTitleWefeat:
    "heapsgo.referralOverview.ticketTitle.wefeat",
  heapsgoReferralOverviewTicketTitleWedo:
    "heapsgo.referralOverview.ticketTitle.wedo",
  heapsgoReferralOverviewTicketTitleTsutsu:
    "heapsgo.referralOverview.ticketTitle.tsutsu",
  heapsgoReferralOverviewTicketTitleTheburgerconcept:
    "heapsgo.referralOverview.ticketTitle.theburgerconcept",
  heapsgoReferralOverviewTicketTitleSmag:
    "heapsgo.referralOverview.ticketTitle.smag",
  heapsgoReferralOverviewTicketTitlePalaeo:
    "heapsgo.referralOverview.ticketTitle.palaeo",
  heapsgoReferralOverviewTicketTitleOlioli:
    "heapsgo.referralOverview.ticketTitle.olioli",
  heapsgoReferralOverviewTicketTitleMaexico:
    "heapsgo.referralOverview.ticketTitle.maexico",
  heapsgoReferralOverviewTicketTitleKcalfactory:
    "heapsgo.referralOverview.ticketTitle.kcalfactory",
  heapsgoReferralOverviewTicketTitleJagger:
    "heapsgo.referralOverview.ticketTitle.jagger",
  heapsgoReferralOverviewTicketTitleHumblepie:
    "heapsgo.referralOverview.ticketTitle.humblepie",
  heapsgoReferralOverviewTicketTitleHubb:
    "heapsgo.referralOverview.ticketTitle.hubb",
  heapsgoReferralOverviewTicketTitleGroed:
    "heapsgo.referralOverview.ticketTitle.groed",
  heapsgoReferralOverviewTicketTitleGorms:
    "heapsgo.referralOverview.ticketTitle.gorms",
  heapsgoReferralOverviewTicketTitleGarbanzo:
    "heapsgo.referralOverview.ticketTitle.garbanzo",
  heapsgoReferralOverviewTicketTitleFrankies:
    "heapsgo.referralOverview.ticketTitle.frankies",
  heapsgoReferralOverviewTicketTitleEdenjaxx:
    "heapsgo.referralOverview.ticketTitle.edenjaxx",
  heapsgoReferralOverviewTicketTitleCocorico:
    "heapsgo.referralOverview.ticketTitle.cocorico",
  heapsgoReferralOverviewTicketTitleCaspers:
    "heapsgo.referralOverview.ticketTitle.caspers",
  heapsgoReferralOverviewTicketTitleBurgerbeast:
    "heapsgo.referralOverview.ticketTitle.burgerbeast",
  heapsgoReferralOverviewTicketTitleBuns:
    "heapsgo.referralOverview.ticketTitle.buns",
  heapsgoReferralOverviewTicketTitleBoff:
    "heapsgo.referralOverview.ticketTitle.boff",
  heapsgoReferralOverviewTicketTitleBlokksmash:
    "heapsgo.referralOverview.ticketTitle.blokksmash",
  heapsgoReferralOverviewTicketTitleBiteline:
    "heapsgo.referralOverview.ticketTitle.biteline",
  heapsgoReferralOverviewTicketTitleBindia:
    "heapsgo.referralOverview.ticketTitle.bindia",
  heapsgoReferralOverviewTicketTitleAmanogroup:
    "heapsgo.referralOverview.ticketTitle.amanogroup",
  heapsgoReferralOverviewTicketTitleWaldorfGroup:
    "heapsgo.referralOverview.ticketTitle.Waldorf.Group",
  heapsgoReferralOverviewTicketTitleTommis:
    "heapsgo.referralOverview.ticketTitle.Tommis",
  heapsgoReferralOverviewTicketTitleTheFatGreek:
    "heapsgo.referralOverview.ticketTitle.TheFatGreek",
  heapsgoReferralOverviewTicketTitleStrangas:
    "heapsgo.referralOverview.ticketTitle.Strangas",
  heapsgoReferralOverviewTicketTitleStacys:
    "heapsgo.referralOverview.ticketTitle.Stacys",
  heapsgoReferralOverviewTicketTitleShabaz:
    "heapsgo.referralOverview.ticketTitle.Shabaz",
  heapsgoReferralOverviewTicketTitleSandwichpigen:
    "heapsgo.referralOverview.ticketTitle.Sandwichpigen",
  heapsgoReferralOverviewTicketTitleSURTX:
    "heapsgo.referralOverview.ticketTitle.SURT2",
  heapsgoReferralOverviewTicketTitleRollneat:
    "heapsgo.referralOverview.ticketTitle.Rollneat",
  heapsgoReferralOverviewTicketTitleRaSushi:
    "heapsgo.referralOverview.ticketTitle.RaSushi",
  heapsgoReferralOverviewTicketTitlePureGreensClub:
    "heapsgo.referralOverview.ticketTitle.PureGreensClub",
  heapsgoReferralOverviewTicketTitleParadis:
    "heapsgo.referralOverview.ticketTitle.Paradis",
  heapsgoReferralOverviewTicketTitlePanzanella:
    "heapsgo.referralOverview.ticketTitle.Panzanella",
  heapsgoReferralOverviewTicketTitlePHAGO:
    "heapsgo.referralOverview.ticketTitle.PHAGO",
  heapsgoReferralOverviewTicketTitleOAKBERRY:
    "heapsgo.referralOverview.ticketTitle.OAKBERRY",
  heapsgoReferralOverviewTicketTitleNOAHS:
    "heapsgo.referralOverview.ticketTitle.NOAHS",
  heapsgoReferralOverviewTicketTitleMubanthai:
    "heapsgo.referralOverview.ticketTitle.Mubanthai",
  heapsgoReferralOverviewTicketTitleMaikai:
    "heapsgo.referralOverview.ticketTitle.Maikai",
  heapsgoReferralOverviewTicketTitleMadklubben:
    "heapsgo.referralOverview.ticketTitle.Madklubben",
  heapsgoReferralOverviewTicketTitleMaMeMi:
    "heapsgo.referralOverview.ticketTitle.MaMeMi",
  heapsgoReferralOverviewTicketTitleLighthouseburger:
    "heapsgo.referralOverview.ticketTitle.Lighthouseburger",
  heapsgoReferralOverviewTicketTitleLetzsushi:
    "heapsgo.referralOverview.ticketTitle.Letzsushi",
  heapsgoReferralOverviewTicketTitleKyllingCo:
    "heapsgo.referralOverview.ticketTitle.KyllingCo",
  heapsgoReferralOverviewTicketTitleKillerkebab:
    "heapsgo.referralOverview.ticketTitle.Killerkebab",
  heapsgoReferralOverviewTicketTitleIscafeen:
    "heapsgo.referralOverview.ticketTitle.Iscafeen",
  heapsgoReferralOverviewTicketTitleIRONWOK:
    "heapsgo.referralOverview.ticketTitle.IRONWOK",
  heapsgoReferralOverviewTicketTitleIKISUSHI:
    "heapsgo.referralOverview.ticketTitle.IKISUSHI",
  heapsgoReferralOverviewTicketTitleHellopasta:
    "heapsgo.referralOverview.ticketTitle.Hellopasta",
  heapsgoReferralOverviewTicketTitleGoldenroost:
    "heapsgo.referralOverview.ticketTitle.Goldenroost",
  heapsgoReferralOverviewTicketTitleGeppetto:
    "heapsgo.referralOverview.ticketTitle.Geppetto",
  heapsgoReferralOverviewTicketTitleGaodumpling:
    "heapsgo.referralOverview.ticketTitle.Gaodumpling",
  heapsgoReferralOverviewTicketTitleFrederiksbergSmørrebrød:
    "heapsgo.referralOverview.ticketTitle.Frederiksberg.Smørrebrød",
  heapsgoReferralOverviewTicketTitleFlyChicken:
    "heapsgo.referralOverview.ticketTitle.FlyChicken",
  heapsgoReferralOverviewTicketTitleEvald:
    "heapsgo.referralOverview.ticketTitle.Evald",
  heapsgoReferralOverviewTicketTitleDistrictTonkin:
    "heapsgo.referralOverview.ticketTitle.DistrictTonkin",
  heapsgoReferralOverviewTicketTitleDiamondSlice:
    "heapsgo.referralOverview.ticketTitle.DiamondSlice",
  heapsgoReferralOverviewTicketTitleDhaba:
    "heapsgo.referralOverview.ticketTitle.Dhaba",
  heapsgoReferralOverviewTicketTitleDandelion:
    "heapsgo.referralOverview.ticketTitle.Dandelion",
  heapsgoReferralOverviewTicketTitleChavez:
    "heapsgo.referralOverview.ticketTitle.Chavez",
  heapsgoReferralOverviewTicketTitleBurgerShack:
    "heapsgo.referralOverview.ticketTitle.BurgerShack",
  heapsgoReferralOverviewTicketTitleBaryl:
    "heapsgo.referralOverview.ticketTitle.Baryl",
  heapsgoReferralOverviewTicketTitleBanhBanh:
    "heapsgo.referralOverview.ticketTitle.BanhBanh",
  heapsgoReferralOverviewTicketTitleBONES:
    "heapsgo.referralOverview.ticketTitle.BONES",
  heapsgoReferralOverviewTicketTitleBADSHA:
    "heapsgo.referralOverview.ticketTitle.BADSHA",
  heapsgoReferralOverviewTicketTitleANOTHERPIZZA:
    "heapsgo.referralOverview.ticketTitle.ANOTHERPIZZA",
  heapsgoReferralOverviewShareWefeat: "heapsgo.referralOverview.share.wefeat",
  heapsgoReferralOverviewShareWedo: "heapsgo.referralOverview.share.wedo",
  heapsgoReferralOverviewShareTsutsu: "heapsgo.referralOverview.share.tsutsu",
  heapsgoReferralOverviewShareTheburgerconcept:
    "heapsgo.referralOverview.share.theburgerconcept",
  heapsgoReferralOverviewShareSmag: "heapsgo.referralOverview.share.smag",
  heapsgoReferralOverviewSharePalaeo: "heapsgo.referralOverview.share.palaeo",
  heapsgoReferralOverviewShareOlioli: "heapsgo.referralOverview.share.olioli",
  heapsgoReferralOverviewShareMaexico: "heapsgo.referralOverview.share.maexico",
  heapsgoReferralOverviewShareKcalfactory:
    "heapsgo.referralOverview.share.kcalfactory",
  heapsgoReferralOverviewShareJagger: "heapsgo.referralOverview.share.jagger",
  heapsgoReferralOverviewShareHumblepie:
    "heapsgo.referralOverview.share.humblepie",
  heapsgoReferralOverviewShareHubb: "heapsgo.referralOverview.share.hubb",
  heapsgoReferralOverviewShareGroed: "heapsgo.referralOverview.share.groed",
  heapsgoReferralOverviewShareGorms: "heapsgo.referralOverview.share.gorms",
  heapsgoReferralOverviewShareGarbanzo:
    "heapsgo.referralOverview.share.garbanzo",
  heapsgoReferralOverviewShareFrankies:
    "heapsgo.referralOverview.share.frankies",
  heapsgoReferralOverviewShareEdenjaxx:
    "heapsgo.referralOverview.share.edenjaxx",
  heapsgoReferralOverviewShareCocorico:
    "heapsgo.referralOverview.share.cocorico",
  heapsgoReferralOverviewShareBuzzcph: "heapsgo.referralOverview.share.buzzcph",
  heapsgoReferralOverviewShareBurgerbeast:
    "heapsgo.referralOverview.share.burgerbeast",
  heapsgoReferralOverviewShareBuns: "heapsgo.referralOverview.share.buns",
  heapsgoReferralOverviewShareBoff: "heapsgo.referralOverview.share.boff",
  heapsgoReferralOverviewShareBlokksmash:
    "heapsgo.referralOverview.share.blokksmash",
  heapsgoReferralOverviewShareBiteline:
    "heapsgo.referralOverview.share.biteline",
  heapsgoReferralOverviewShareBindia: "heapsgo.referralOverview.share.bindia",
  heapsgoReferralOverviewShareAmanogroup:
    "heapsgo.referralOverview.share.amanogroup",
  heapsgoReferralOverviewShareWaldorfGroup:
    "heapsgo.referralOverview.share.Waldorf.Group",
  heapsgoReferralOverviewShareTommis: "heapsgo.referralOverview.share.Tommis",
  heapsgoReferralOverviewShareTheFatGreek:
    "heapsgo.referralOverview.share.TheFatGreek",
  heapsgoReferralOverviewShareStrangas:
    "heapsgo.referralOverview.share.Strangas",
  heapsgoReferralOverviewShareStacys: "heapsgo.referralOverview.share.Stacys",
  heapsgoReferralOverviewShareShabaz: "heapsgo.referralOverview.share.Shabaz",
  heapsgoReferralOverviewShareSandwichpigen:
    "heapsgo.referralOverview.share.Sandwichpigen",
  heapsgoReferralOverviewShareSURTX: "heapsgo.referralOverview.share.SURT2",
  heapsgoReferralOverviewShareRollneat:
    "heapsgo.referralOverview.share.Rollneat",
  heapsgoReferralOverviewShareRaSushi: "heapsgo.referralOverview.share.RaSushi",
  heapsgoReferralOverviewSharePureGreensClub:
    "heapsgo.referralOverview.share.PureGreensClub",
  heapsgoReferralOverviewSharePicoPizza:
    "heapsgo.referralOverview.share.PicoPizza",
  heapsgoReferralOverviewShareParadis: "heapsgo.referralOverview.share.Paradis",
  heapsgoReferralOverviewSharePanzanella:
    "heapsgo.referralOverview.share.Panzanella",
  heapsgoReferralOverviewSharePHAGO: "heapsgo.referralOverview.share.PHAGO",
  heapsgoReferralOverviewShareOAKBERRY:
    "heapsgo.referralOverview.share.OAKBERRY",
  heapsgoReferralOverviewShareNOAHS: "heapsgo.referralOverview.share.NOAHS",
  heapsgoReferralOverviewShareMubanthai:
    "heapsgo.referralOverview.share.Mubanthai",
  heapsgoReferralOverviewShareMaikai: "heapsgo.referralOverview.share.Maikai",
  heapsgoReferralOverviewShareMadklubben:
    "heapsgo.referralOverview.share.Madklubben",
  heapsgoReferralOverviewShareMaMeMi: "heapsgo.referralOverview.share.MaMeMi",
  heapsgoReferralOverviewShareLighthouseburger:
    "heapsgo.referralOverview.share.Lighthouseburger",
  heapsgoReferralOverviewShareLetzsushi:
    "heapsgo.referralOverview.share.Letzsushi",
  heapsgoReferralOverviewShareKyllingCo:
    "heapsgo.referralOverview.share.KyllingCo",
  heapsgoReferralOverviewShareKillerkebab:
    "heapsgo.referralOverview.share.Killerkebab",
  heapsgoReferralOverviewShareIRONWOK: "heapsgo.referralOverview.share.IRONWOK",
  heapsgoReferralOverviewShareIKISUSHI:
    "heapsgo.referralOverview.share.IKISUSHI",
  heapsgoReferralOverviewShareHellopasta:
    "heapsgo.referralOverview.share.Hellopasta",
  heapsgoReferralOverviewShareGoldenroost:
    "heapsgo.referralOverview.share.Goldenroost",
  heapsgoReferralOverviewShareGeppetto:
    "heapsgo.referralOverview.share.Geppetto",
  heapsgoReferralOverviewShareGaodumpling:
    "heapsgo.referralOverview.share.Gaodumpling",
  heapsgoReferralOverviewShareFrederiksbergSmørrebrød:
    "heapsgo.referralOverview.share.Frederiksberg.Smørrebrød",
  heapsgoReferralOverviewShareFlyChicken:
    "heapsgo.referralOverview.share.FlyChicken",
  heapsgoReferralOverviewShareEvald: "heapsgo.referralOverview.share.Evald",
  heapsgoReferralOverviewShareDistrictTonkin:
    "heapsgo.referralOverview.share.DistrictTonkin",
  heapsgoReferralOverviewShareDiamondSlice:
    "heapsgo.referralOverview.share.DiamondSlice",
  heapsgoReferralOverviewShareDhaba: "heapsgo.referralOverview.share.Dhaba",
  heapsgoReferralOverviewShareDandelion:
    "heapsgo.referralOverview.share.Dandelion",
  heapsgoReferralOverviewShareChavez: "heapsgo.referralOverview.share.Chavez",
  heapsgoReferralOverviewShareCaspers: "heapsgo.referralOverview.share.Caspers",
  heapsgoReferralOverviewShareBurgerShack:
    "heapsgo.referralOverview.share.BurgerShack",
  heapsgoReferralOverviewShareBaryl: "heapsgo.referralOverview.share.Baryl",
  heapsgoReferralOverviewShareBanhBanh:
    "heapsgo.referralOverview.share.BanhBanh",
  heapsgoReferralOverviewShareBONES: "heapsgo.referralOverview.share.BONES",
  heapsgoReferralOverviewShareBADSHA: "heapsgo.referralOverview.share.BADSHA",
  heapsgoReferralOverviewShareANOTHERPIZZA:
    "heapsgo.referralOverview.share.ANOTHERPIZZA",
  heapsgoReferralOverviewShare: "heapsgo.referralOverview.share",
  heapsgoReferralOverviewDescriptionWefeatorganic:
    "heapsgo.referralOverview.description.wefeatorganic",
  heapsgoReferralOverviewDescriptionWefeat:
    "heapsgo.referralOverview.description.wefeat",
  heapsgoReferralOverviewDescriptionWedo:
    "heapsgo.referralOverview.description.wedo",
  heapsgoReferralOverviewDescriptionTsutsu:
    "heapsgo.referralOverview.description.tsutsu",
  heapsgoReferralOverviewDescriptionTheburgerconcept:
    "heapsgo.referralOverview.description.theburgerconcept",
  heapsgoReferralOverviewDescriptionSmag:
    "heapsgo.referralOverview.description.smag",
  heapsgoReferralOverviewDescriptionPalaeo:
    "heapsgo.referralOverview.description.palaeo",
  heapsgoReferralOverviewDescriptionOlioli:
    "heapsgo.referralOverview.description.olioli",
  heapsgoReferralOverviewDescriptionMaexico:
    "heapsgo.referralOverview.description.maexico",
  heapsgoReferralOverviewDescriptionKcalfactory:
    "heapsgo.referralOverview.description.kcalfactory",
  heapsgoReferralOverviewDescriptionJagger:
    "heapsgo.referralOverview.description.jagger",
  heapsgoReferralOverviewDescriptionHumblepie:
    "heapsgo.referralOverview.description.humblepie",
  heapsgoReferralOverviewDescriptionHubb:
    "heapsgo.referralOverview.description.hubb",
  heapsgoReferralOverviewDescriptionGroed:
    "heapsgo.referralOverview.description.groed",
  heapsgoReferralOverviewDescriptionGorms:
    "heapsgo.referralOverview.description.gorms",
  heapsgoReferralOverviewDescriptionGarbanzo:
    "heapsgo.referralOverview.description.garbanzo",
  heapsgoReferralOverviewDescriptionFrankies:
    "heapsgo.referralOverview.description.frankies",
  heapsgoReferralOverviewDescriptionEdenjaxx:
    "heapsgo.referralOverview.description.edenjaxx",
  heapsgoReferralOverviewDescriptionCocorico:
    "heapsgo.referralOverview.description.cocorico",
  heapsgoReferralOverviewDescriptionCaspers:
    "heapsgo.referralOverview.description.caspers",
  heapsgoReferralOverviewDescriptionBuzzcph:
    "heapsgo.referralOverview.description.buzzcph",
  heapsgoReferralOverviewDescriptionBurgerbeast:
    "heapsgo.referralOverview.description.burgerbeast",
  heapsgoReferralOverviewDescriptionBuns:
    "heapsgo.referralOverview.description.buns",
  heapsgoReferralOverviewDescriptionBoff:
    "heapsgo.referralOverview.description.boff",
  heapsgoReferralOverviewDescriptionBlokksmash:
    "heapsgo.referralOverview.description.blokksmash",
  heapsgoReferralOverviewDescriptionBiteline:
    "heapsgo.referralOverview.description.biteline",
  heapsgoReferralOverviewDescriptionBindia:
    "heapsgo.referralOverview.description.bindia",
  heapsgoReferralOverviewDescriptionAmanogroup:
    "heapsgo.referralOverview.description.amanogroup",
  heapsgoReferralOverviewDescriptionWaldorfGroup:
    "heapsgo.referralOverview.description.Waldorf.Group",
  heapsgoReferralOverviewDescriptionTommis:
    "heapsgo.referralOverview.description.Tommis",
  heapsgoReferralOverviewDescriptionTheFatGreek:
    "heapsgo.referralOverview.description.TheFatGreek",
  heapsgoReferralOverviewDescriptionStrangas:
    "heapsgo.referralOverview.description.Strangas",
  heapsgoReferralOverviewDescriptionStacys:
    "heapsgo.referralOverview.description.Stacys",
  heapsgoReferralOverviewDescriptionShabaz:
    "heapsgo.referralOverview.description.Shabaz",
  heapsgoReferralOverviewDescriptionSandwichpigen:
    "heapsgo.referralOverview.description.Sandwichpigen",
  heapsgoReferralOverviewDescriptionSURTX:
    "heapsgo.referralOverview.description.SURT2",
  heapsgoReferralOverviewDescriptionRollneat:
    "heapsgo.referralOverview.description.Rollneat",
  heapsgoReferralOverviewDescriptionRaSushi:
    "heapsgo.referralOverview.description.RaSushi",
  heapsgoReferralOverviewDescriptionPureGreensClub:
    "heapsgo.referralOverview.description.PureGreensClub",
  heapsgoReferralOverviewDescriptionPicoPizza:
    "heapsgo.referralOverview.description.PicoPizza",
  heapsgoReferralOverviewDescriptionParadis:
    "heapsgo.referralOverview.description.Paradis",
  heapsgoReferralOverviewDescriptionPanzanella:
    "heapsgo.referralOverview.description.Panzanella",
  heapsgoReferralOverviewDescriptionPHAGO:
    "heapsgo.referralOverview.description.PHAGO",
  heapsgoReferralOverviewDescriptionOAKBERRY:
    "heapsgo.referralOverview.description.OAKBERRY",
  heapsgoReferralOverviewDescriptionNOAHS:
    "heapsgo.referralOverview.description.NOAHS",
  heapsgoReferralOverviewDescriptionMubanthai:
    "heapsgo.referralOverview.description.Mubanthai",
  heapsgoReferralOverviewDescriptionMaikai:
    "heapsgo.referralOverview.description.Maikai",
  heapsgoReferralOverviewDescriptionMadklubben:
    "heapsgo.referralOverview.description.Madklubben",
  heapsgoReferralOverviewDescriptionMaMeMi:
    "heapsgo.referralOverview.description.MaMeMi",
  heapsgoReferralOverviewDescriptionLighthouseburger:
    "heapsgo.referralOverview.description.Lighthouseburger",
  heapsgoReferralOverviewDescriptionLetzsushi:
    "heapsgo.referralOverview.description.Letzsushi",
  heapsgoReferralOverviewDescriptionKyllingCo:
    "heapsgo.referralOverview.description.KyllingCo",
  heapsgoReferralOverviewDescriptionKillerkebab:
    "heapsgo.referralOverview.description.Killerkebab",
  heapsgoReferralOverviewDescriptionIscafeen:
    "heapsgo.referralOverview.description.Iscafeen",
  heapsgoReferralOverviewDescriptionIRONWOK:
    "heapsgo.referralOverview.description.IRONWOK",
  heapsgoReferralOverviewDescriptionIKISUSHI:
    "heapsgo.referralOverview.description.IKISUSHI",
  heapsgoReferralOverviewDescriptionHellopasta:
    "heapsgo.referralOverview.description.Hellopasta",
  heapsgoReferralOverviewDescriptionGoldenroost:
    "heapsgo.referralOverview.description.Goldenroost",
  heapsgoReferralOverviewDescriptionGeppetto:
    "heapsgo.referralOverview.description.Geppetto",
  heapsgoReferralOverviewDescriptionGaodumpling:
    "heapsgo.referralOverview.description.Gaodumpling",
  heapsgoReferralOverviewDescriptionFrederiksbergSmørrebrød:
    "heapsgo.referralOverview.description.Frederiksberg.Smørrebrød",
  heapsgoReferralOverviewDescriptionFlyChicken:
    "heapsgo.referralOverview.description.FlyChicken",
  heapsgoReferralOverviewDescriptionEvald:
    "heapsgo.referralOverview.description.Evald",
  heapsgoReferralOverviewDescriptionDistrictTonkin:
    "heapsgo.referralOverview.description.DistrictTonkin",
  heapsgoReferralOverviewDescriptionDiamondSlice:
    "heapsgo.referralOverview.description.DiamondSlice",
  heapsgoReferralOverviewDescriptionDhaba:
    "heapsgo.referralOverview.description.Dhaba",
  heapsgoReferralOverviewDescriptionDandelion:
    "heapsgo.referralOverview.description.Dandelion",
  heapsgoReferralOverviewDescriptionChavez:
    "heapsgo.referralOverview.description.Chavez",
  heapsgoReferralOverviewDescriptionBurgerShack:
    "heapsgo.referralOverview.description.BurgerShack",
  heapsgoReferralOverviewDescriptionBaryl:
    "heapsgo.referralOverview.description.Baryl",
  heapsgoReferralOverviewDescriptionBanhBanh:
    "heapsgo.referralOverview.description.BanhBanh",
  heapsgoReferralOverviewDescriptionBONES:
    "heapsgo.referralOverview.description.BONES",
  heapsgoReferralOverviewDescriptionBADSHA:
    "heapsgo.referralOverview.description.BADSHA",
  heapsgoReferralOverviewDescriptionANOTHERPIZZA:
    "heapsgo.referralOverview.description.ANOTHERPIZZA",
  heapsgoReferralInvitetitleWedo: "heapsgo.referral.invitetitle.wedo",
  heapsgoReferralInvitetitleTsutsu: "heapsgo.referral.invitetitle.tsutsu",
  heapsgoReferralInvitetitleTheburgerconcept:
    "heapsgo.referral.invitetitle.theburgerconcept",
  heapsgoReferralInvitetitleSmag: "heapsgo.referral.invitetitle.smag",
  heapsgoReferralInvitetitlePalaeo: "heapsgo.referral.invitetitle.palaeo",
  heapsgoReferralInvitetitleOlioli: "heapsgo.referral.invitetitle.olioli",
  heapsgoReferralInvitetitleMaexico: "heapsgo.referral.invitetitle.maexico",
  heapsgoReferralInvitetitleKcalfactory:
    "heapsgo.referral.invitetitle.kcalfactory",
  heapsgoReferralInvitetitleJagger: "heapsgo.referral.invitetitle.jagger",
  heapsgoReferralInvitetitleHumblepie: "heapsgo.referral.invitetitle.humblepie",
  heapsgoReferralInvitetitleGroed: "heapsgo.referral.invitetitle.groed",
  heapsgoReferralInvitetitleGorms: "heapsgo.referral.invitetitle.gorms",
  heapsgoReferralInvitetitleFrankies: "heapsgo.referral.invitetitle.frankies",
  heapsgoReferralInvitetitleEdenjaxx: "heapsgo.referral.invitetitle.edenjaxx",
  heapsgoReferralInvitetitleCocorico: "heapsgo.referral.invitetitle.cocorico",
  heapsgoReferralInvitetitleCaspers: "heapsgo.referral.invitetitle.caspers",
  heapsgoReferralInvitetitleBuzzcph: "heapsgo.referral.invitetitle.buzzcph",
  heapsgoReferralInvitetitleBurgerbeast:
    "heapsgo.referral.invitetitle.burgerbeast",
  heapsgoReferralInvitetitleBuns: "heapsgo.referral.invitetitle.buns",
  heapsgoReferralInvitetitleBoff: "heapsgo.referral.invitetitle.boff",
  heapsgoReferralInvitetitleBlokksmash:
    "heapsgo.referral.invitetitle.blokksmash",
  heapsgoReferralInvitetitleBiteline: "heapsgo.referral.invitetitle.biteline",
  heapsgoReferralInvitetitleBindia: "heapsgo.referral.invitetitle.bindia",
  heapsgoReferralInvitetitleAmanogroup:
    "heapsgo.referral.invitetitle.amanogroup",
  heapsgoReferralInvitetitleWaldorfGroup:
    "heapsgo.referral.invitetitle.Waldorf.Group",
  heapsgoReferralInvitetitleTommis: "heapsgo.referral.invitetitle.Tommis",
  heapsgoReferralInvitetitleTheFatGreek:
    "heapsgo.referral.invitetitle.TheFatGreek",
  heapsgoReferralInvitetitleStrangas: "heapsgo.referral.invitetitle.Strangas",
  heapsgoReferralInvitetitleStacys: "heapsgo.referral.invitetitle.Stacys",
  heapsgoReferralInvitetitleShabaz: "heapsgo.referral.invitetitle.Shabaz",
  heapsgoReferralInvitetitleSandwichpigen:
    "heapsgo.referral.invitetitle.Sandwichpigen",
  heapsgoReferralInvitetitleSURTX: "heapsgo.referral.invitetitle.SURT2",
  heapsgoReferralInvitetitleRollneat: "heapsgo.referral.invitetitle.Rollneat",
  heapsgoReferralInvitetitleRaSushi: "heapsgo.referral.invitetitle.RaSushi",
  heapsgoReferralInvitetitlePureGreensClub:
    "heapsgo.referral.invitetitle.PureGreensClub",
  heapsgoReferralInvitetitlePicoPizza: "heapsgo.referral.invitetitle.PicoPizza",
  heapsgoReferralInvitetitleParadis: "heapsgo.referral.invitetitle.Paradis",
  heapsgoReferralInvitetitlePanzanella:
    "heapsgo.referral.invitetitle.Panzanella",
  heapsgoReferralInvitetitlePHAGO: "heapsgo.referral.invitetitle.PHAGO",
  heapsgoReferralInvitetitleOAKBERRY: "heapsgo.referral.invitetitle.OAKBERRY",
  heapsgoReferralInvitetitleNOAHS: "heapsgo.referral.invitetitle.NOAHS",
  heapsgoReferralInvitetitleMubanthai: "heapsgo.referral.invitetitle.Mubanthai",
  heapsgoReferralInvitetitleMaikai: "heapsgo.referral.invitetitle.Maikai",
  heapsgoReferralInvitetitleMadklubben:
    "heapsgo.referral.invitetitle.Madklubben",
  heapsgoReferralInvitetitleMaMeMi: "heapsgo.referral.invitetitle.MaMeMi",
  heapsgoReferralInvitetitleLighthouseburger:
    "heapsgo.referral.invitetitle.Lighthouseburger",
  heapsgoReferralInvitetitleLetzsushi: "heapsgo.referral.invitetitle.Letzsushi",
  heapsgoReferralInvitetitleKyllingCo: "heapsgo.referral.invitetitle.KyllingCo",
  heapsgoReferralInvitetitleKillerkebab:
    "heapsgo.referral.invitetitle.Killerkebab",
  heapsgoReferralInvitetitleIscafeen: "heapsgo.referral.invitetitle.Iscafeen",
  heapsgoReferralInvitetitleIRONWOK: "heapsgo.referral.invitetitle.IRONWOK",
  heapsgoReferralInvitetitleIKISUSHI: "heapsgo.referral.invitetitle.IKISUSHI",
  heapsgoReferralInvitetitleHellopasta:
    "heapsgo.referral.invitetitle.Hellopasta",
  heapsgoReferralInvitetitleGoldenroost:
    "heapsgo.referral.invitetitle.Goldenroost",
  heapsgoReferralInvitetitleGeppetto: "heapsgo.referral.invitetitle.Geppetto",
  heapsgoReferralInvitetitleGaodumpling:
    "heapsgo.referral.invitetitle.Gaodumpling",
  heapsgoReferralInvitetitleFrederiksbergSmørrebrød:
    "heapsgo.referral.invitetitle.Frederiksberg.Smørrebrød",
  heapsgoReferralInvitetitleFlyChicken:
    "heapsgo.referral.invitetitle.FlyChicken",
  heapsgoReferralInvitetitleEvald: "heapsgo.referral.invitetitle.Evald",
  heapsgoReferralInvitetitleDistrictTonkin:
    "heapsgo.referral.invitetitle.DistrictTonkin",
  heapsgoReferralInvitetitleDiamondSlice:
    "heapsgo.referral.invitetitle.DiamondSlice",
  heapsgoReferralInvitetitleDhaba: "heapsgo.referral.invitetitle.Dhaba",
  heapsgoReferralInvitetitleDandelion: "heapsgo.referral.invitetitle.Dandelion",
  heapsgoReferralInvitetitleChavez: "heapsgo.referral.invitetitle.Chavez",
  heapsgoReferralInvitetitleBurgerShack:
    "heapsgo.referral.invitetitle.BurgerShack",
  heapsgoReferralInvitetitleBaryl: "heapsgo.referral.invitetitle.Baryl",
  heapsgoReferralInvitetitleBanhBanh: "heapsgo.referral.invitetitle.BanhBanh",
  heapsgoReferralInvitetitleBONES: "heapsgo.referral.invitetitle.BONES",
  heapsgoReferralInvitetitleBADSHA: "heapsgo.referral.invitetitle.BADSHA",
  heapsgoReferralInvitetitleANOTHERPIZZA:
    "heapsgo.referral.invitetitle.ANOTHERPIZZA",
  heapsgoReferralDescription: "heapsgo.referral.description",
  heapsgoPaymentPaymentCompleted: "heapsgo.payment.paymentCompleted",
  heapsgoCreditCardErrorAddedbyAnotherUser:
    "heapsgo.creditCard.error.addedbyAnotherUser",
  heapsgoAddToTableVenueListTitle: "heapsgo.addToTable.venueListTitle",
  heapsgoAddToTableVenueListDescription:
    "heapsgo.addToTable.venueListDescription",
  heapsgoAddToTableTableNumber: "heapsgo.addToTable.tableNumber",
  heapsgoAddToTableScanQr: "heapsgo.addToTable.scanQr",
  heapsgoAddToTablePlayOrderPayTitle: "heapsgo.addToTable.playOrderPayTitle",
  heapsgoAddToTablePlaceOrderTitle: "heapsgo.addToTable.placeOrderTitle",
  heapsgoAddToTablePlaceOrderDescription:
    "heapsgo.addToTable.placeOrderDescription",
  heapsgoAddToTableOrderReceivedTitle: "heapsgo.addToTable.orderReceivedTitle",
  heapsgoAddToTableOrderReceivedDescription:
    "heapsgo.addToTable.orderReceivedDescription",
  heapsgoAddToTableMyTableTitle: "heapsgo.addToTable.myTableTitle",
  heapsgoAddToTableMyTableCta: "heapsgo.addToTable.myTableCta",
  heapsgoAddToTableEnterTableNumerTitle:
    "heapsgo.addToTable.enterTableNumerTitle",
  heapsgoAddToTableEnterTableNumerDescription:
    "heapsgo.addToTable.enterTableNumerDescription",
  heapsgoAddToTableCtaTitle: "heapsgo.addToTable.ctaTitle",
  heapsgoAddToTableAddToTableTitle: "heapsgo.addToTable.addToTableTitle",
  heapsgoAddToTableAddProductTitle: "heapsgo.addToTable.addProductTitle",
  heapsgoAddToTableAddProductDescription:
    "heapsgo.addToTable.addProductDescription",
  heapsgoAddToTableAddProductConfirm: "heapsgo.addToTable.addProductConfirm",
  groedSlogan: "groed.slogan",
  groedGroedFamily: "groed.groedFamily",
  groedGroed: "groed.groed",
  deliveryChooseAddress: "delivery.choose.address",
  ctaSavePreferences: "cta.save.preferences",
  ctaAcceptAll: "cta.accept.all",
  cookies: "cookies",
  confirmPaymentPopupTitle: "confirm.payment.popup.title",
  confirmPaymentPopupSubtitle: "confirm.payment.popup.subtitle",
  confirmPaymentPopupPrompt: "confirm.payment.popup.prompt",
  confirmPaymentPopupOrder: "confirm.payment.popup.order",
  confirmPaymentPopupCancel: "confirm.payment.popup.cancel",
  confirmCodeValidatingCode: "confirm.code.validating.code",
  commonSwishPaymentTitle: "common.swish.payment.title",
  commonSwishPaymentDescription: "common.swish.payment.description",
  commonMissingSharedSelectionsTitile:
    "common.missing.shared.selections.titile",
  comboYourProfile: "combo.your.profile",
  comboWelcomeLogind: "combo.welcome.logind",
  comboWebFooterUsefulLinks: "combo.web.footer.useful.links",
  comboWalletVouchersubtitle: "combo.wallet.vouchersubtitle",
  comboWalletVouchersVoucherSpentTitle:
    "combo.wallet.vouchers.voucherSpentTitle",
  comboWalletVouchersVoucherSpentMessage:
    "combo.wallet.vouchers.voucherSpentMessage",
  comboWalletVouchersUseVoucher: "combo.wallet.vouchers.useVoucher",
  comboWalletVouchersSwipeToUse: "combo.wallet.vouchers.swipeToUse",
  comboWalletVouchersProcessing: "combo.wallet.vouchers.processing",
  comboWalletVouchersOrUseWithBeacon: "combo.wallet.vouchers.orUseWithBeacon",
  comboWalletVoucherleft: "combo.wallet.voucherleft",
  comboWalletVoucheradded: "combo.wallet.voucheradded",
  comboWalletVerifyPhoneNumberTitle: "combo.wallet.verifyPhoneNumber.title",
  comboWalletVerifyPhoneNumberDescription:
    "combo.wallet.verifyPhoneNumber.description",
  comboWalletVerifyPhoneNumberButton: "combo.wallet.verifyPhoneNumber.button",
  comboWalletUpdate: "combo.wallet.update",
  comboWalletSuccessTitle: "combo.wallet.success.title",
  comboWalletSuccessMessage: "combo.wallet.success.message",
  comboWalletSuccessMessagePlural: "combo.wallet.success.message.plural",
  comboWalletSubtitleBalancecard: "combo.wallet.subtitle.balancecard",
  comboWalletEnterPromoCodeMessage: "combo.wallet.enterPromoCode.message",
  comboWalletCardtagline: "combo.wallet.cardtagline",
  comboWalletCardsubtext: "combo.wallet.cardsubtext",
  comboWalletCardlabel: "combo.wallet.cardlabel",
  comboWalletCardSubtextfamily: "combo.wallet.card.subtextfamily",
  comboWalletAddvoucherQuantity: "combo.wallet.addvoucher.quantity",
  comboWalletAddvoucher: "combo.wallet.addvoucher",
  comboWalletAddpayment: "combo.wallet.addpayment",
  comboVoucherstackPaymentstatus: "combo.voucherstack.paymentstatus",
  comboVoucherstackBalance: "combo.voucherstack.balance",
  comboVoucherQuantity: "combo.voucher.quantity",
  comboVoucherClaim: "combo.voucher.claim",
  comboVersion_checkOk: "combo.version_check.ok",
  comboVersion_checkHeader: "combo.version_check.header",
  comboVersion_checkCancel: "combo.version_check.cancel",
  comboVersion_checkBody: "combo.version_check.body",
  comboVerifyVerifyButton: "combo.verify.verifyButton",
  comboVerifyTitle: "combo.verify.title",
  comboVerifySubtitle: "combo.verify.subtitle",
  comboVerifyStatusValidatingTitle: "combo.verify.status.validating.title",
  comboVerifyStatusValidatedTitle: "combo.verify.status.validated.title",
  comboVerifyStatusIncorrectTryAgain: "combo.verify.status.incorrect.tryAgain",
  comboVerifyStatusIncorrectTitle: "combo.verify.status.incorrect.title",
  comboVerifyStatusIncorrectSubtitle: "combo.verify.status.incorrect.subtitle",
  comboVerifyPhoneTitle: "combo.verify.phoneTitle",
  comboVerifyDescription: "combo.verify.description",
  comboVerifyCountriesTitle: "combo.verify.countries.title",
  comboVerifyCountriesSubtitle: "combo.verify.countries.subtitle",
  comboVerifyCountriesSearchPlaceholder:
    "combo.verify.countries.search.placeholder",
  comboVerifyCodeTitle: "combo.verify.code.title",
  comboVerifyCodeSupport: "combo.verify.code.support",
  comboVerifyCodeSubtitle: "combo.verify.code.subtitle",
  comboVerifyCodeResendButton: "combo.verify.code.resendButton",
  comboUserMissingSignUpTitleSignUp: "combo.user.missing.sign.up.title.sign.up",
  comboUserMissingSignUpTitleLogIn: "combo.user.missing.sign.up.title.log.in",
  comboUserMissingSignUpDescriptionSignUp:
    "combo.user.missing.sign.up.description.sign.up",
  comboUserMissingSignUpDescriptionLogIn:
    "combo.user.missing.sign.up.description.log.in",
  comboTripleupAddFunds: "combo.tripleup.addFunds",
  comboTomorrow: "combo.tomorrow",
  comboToday: "combo.today",
  comboTicketsExpires: "combo.tickets.expires",
  comboTicketsAddCard: "combo.tickets.addCard",
  comboTicketsAdd: "combo.tickets.add",
  comboSubscriptionSuccessTitleWefeatorganic:
    "combo.subscription.successTitle.wefeatorganic",
  comboSubscriptionSuccessTitleWefeat: "combo.subscription.successTitle.wefeat",
  comboSubscriptionSuccessTitleWedo: "combo.subscription.successTitle.wedo",
  comboSubscriptionSuccessTitleTsutsu: "combo.subscription.successTitle.tsutsu",
  comboSubscriptionSuccessTitleTheburgerconcept:
    "combo.subscription.successTitle.theburgerconcept",
  comboSubscriptionSuccessTitleSmag: "combo.subscription.successTitle.smag",
  comboSubscriptionSuccessTitlePalaeo: "combo.subscription.successTitle.palaeo",
  comboSubscriptionSuccessTitleOlioli: "combo.subscription.successTitle.olioli",
  comboSubscriptionSuccessTitleMaexico:
    "combo.subscription.successTitle.maexico",
  comboSubscriptionSuccessTitleKunguak:
    "combo.subscription.successTitle.kunguak",
  comboSubscriptionSuccessTitleKcalfactory:
    "combo.subscription.successTitle.kcalfactory",
  comboSubscriptionSuccessTitleJagger: "combo.subscription.successTitle.jagger",
  comboSubscriptionSuccessTitleHumblepie:
    "combo.subscription.successTitle.humblepie",
  comboSubscriptionSuccessTitleHubb: "combo.subscription.successTitle.hubb",
  comboSubscriptionSuccessTitleGroed: "combo.subscription.successTitle.groed",
  comboSubscriptionSuccessTitleGorms: "combo.subscription.successTitle.gorms",
  comboSubscriptionSuccessTitleGarbanzo:
    "combo.subscription.successTitle.garbanzo",
  comboSubscriptionSuccessTitleFrankies:
    "combo.subscription.successTitle.frankies",
  comboSubscriptionSuccessTitleEdenjaxx:
    "combo.subscription.successTitle.edenjaxx",
  comboSubscriptionSuccessTitleCocorico:
    "combo.subscription.successTitle.cocorico",
  comboSubscriptionSuccessTitleBuzzcph:
    "combo.subscription.successTitle.buzzcph",
  comboSubscriptionSuccessTitleBurgerbeast:
    "combo.subscription.successTitle.burgerbeast",
  comboSubscriptionSuccessTitleBuns: "combo.subscription.successTitle.buns",
  comboSubscriptionSuccessTitleBoff: "combo.subscription.successTitle.boff",
  comboSubscriptionSuccessTitleBlokksmash:
    "combo.subscription.successTitle.blokksmash",
  comboSubscriptionSuccessTitleBiteline:
    "combo.subscription.successTitle.biteline",
  comboSubscriptionSuccessTitleBindia: "combo.subscription.successTitle.bindia",
  comboSubscriptionSuccessTitleAmanogroup:
    "combo.subscription.successTitle.amanogroup",
  comboSubscriptionSuccessTitleWaldorfGroup:
    "combo.subscription.successTitle.Waldorf.Group",
  comboSubscriptionSuccessTitleTommis: "combo.subscription.successTitle.Tommis",
  comboSubscriptionSuccessTitleTheFatGreek:
    "combo.subscription.successTitle.TheFatGreek",
  comboSubscriptionSuccessTitleStrangas:
    "combo.subscription.successTitle.Strangas",
  comboSubscriptionSuccessTitleStacys: "combo.subscription.successTitle.Stacys",
  comboSubscriptionSuccessTitleShabaz: "combo.subscription.successTitle.Shabaz",
  comboSubscriptionSuccessTitleSandwichpigen:
    "combo.subscription.successTitle.Sandwichpigen",
  comboSubscriptionSuccessTitleSURTX: "combo.subscription.successTitle.SURT2",
  comboSubscriptionSuccessTitleRollneat:
    "combo.subscription.successTitle.Rollneat",
  comboSubscriptionSuccessTitleRaSushi:
    "combo.subscription.successTitle.RaSushi",
  comboSubscriptionSuccessTitlePureGreensClub:
    "combo.subscription.successTitle.PureGreensClub",
  comboSubscriptionSuccessTitlePicopizza:
    "combo.subscription.successTitle.Picopizza",
  comboSubscriptionSuccessTitleParadis:
    "combo.subscription.successTitle.Paradis",
  comboSubscriptionSuccessTitlePanzanella:
    "combo.subscription.successTitle.Panzanella",
  comboSubscriptionSuccessTitlePHAGO: "combo.subscription.successTitle.PHAGO",
  comboSubscriptionSuccessTitleOAKBERRY:
    "combo.subscription.successTitle.OAKBERRY",
  comboSubscriptionSuccessTitleNOAHS: "combo.subscription.successTitle.NOAHS",
  comboSubscriptionSuccessTitleMubanthai:
    "combo.subscription.successTitle.Mubanthai",
  comboSubscriptionSuccessTitleMaikai: "combo.subscription.successTitle.Maikai",
  comboSubscriptionSuccessTitleMadklubben:
    "combo.subscription.successTitle.Madklubben",
  comboSubscriptionSuccessTitleMaMeMi: "combo.subscription.successTitle.MaMeMi",
  comboSubscriptionSuccessTitleLighthouseburger:
    "combo.subscription.successTitle.Lighthouseburger",
  comboSubscriptionSuccessTitleLetzsushi:
    "combo.subscription.successTitle.Letzsushi",
  comboSubscriptionSuccessTitleKyllingCo:
    "combo.subscription.successTitle.KyllingCo",
  comboSubscriptionSuccessTitleKillerkebab:
    "combo.subscription.successTitle.Killerkebab",
  comboSubscriptionSuccessTitleIscafeen:
    "combo.subscription.successTitle.Iscafeen",
  comboSubscriptionSuccessTitleIRONWOK:
    "combo.subscription.successTitle.IRONWOK",
  comboSubscriptionSuccessTitleIKISUSHI:
    "combo.subscription.successTitle.IKISUSHI",
  comboSubscriptionSuccessTitleHellopasta:
    "combo.subscription.successTitle.Hellopasta",
  comboSubscriptionSuccessTitleGoldenroost:
    "combo.subscription.successTitle.Goldenroost",
  comboSubscriptionSuccessTitleGeppetto:
    "combo.subscription.successTitle.Geppetto",
  comboSubscriptionSuccessTitleGaodumpling:
    "combo.subscription.successTitle.Gaodumpling",
  comboSubscriptionSuccessTitleFrederiksbergSmørrebrød:
    "combo.subscription.successTitle.Frederiksberg.Smørrebrød",
  comboSubscriptionSuccessTitleFlyChicken:
    "combo.subscription.successTitle.FlyChicken",
  comboSubscriptionSuccessTitleEvald: "combo.subscription.successTitle.Evald",
  comboSubscriptionSuccessTitleDistrictTonkin:
    "combo.subscription.successTitle.DistrictTonkin",
  comboSubscriptionSuccessTitleDiamondSlice:
    "combo.subscription.successTitle.DiamondSlice",
  comboSubscriptionSuccessTitleDhaba: "combo.subscription.successTitle.Dhaba",
  comboSubscriptionSuccessTitleDandelion:
    "combo.subscription.successTitle.Dandelion",
  comboSubscriptionSuccessTitleChavez: "combo.subscription.successTitle.Chavez",
  comboSubscriptionSuccessTitleCaspers:
    "combo.subscription.successTitle.Caspers",
  comboSubscriptionSuccessTitleBurgerShack:
    "combo.subscription.successTitle.BurgerShack",
  comboSubscriptionSuccessTitleBuka: "combo.subscription.successTitle.Buka",
  comboSubscriptionSuccessTitleBaryl: "combo.subscription.successTitle.Baryl",
  comboSubscriptionSuccessTitleBanhBanh:
    "combo.subscription.successTitle.BanhBanh",
  comboSubscriptionSuccessTitleBONES: "combo.subscription.successTitle.BONES",
  comboSubscriptionSuccessTitleBADSHA: "combo.subscription.successTitle.BADSHA",
  comboSubscriptionSuccessTitleANOTHERPIZZA:
    "combo.subscription.successTitle.ANOTHERPIZZA",
  comboSoldOut: "combo.sold.out",
  comboSignupPhoneHint: "combo.signup.phone.hint",
  comboSignupPasswordHint: "combo.signup.password.hint",
  comboSignupLastNameHint: "combo.signup.lastName.hint",
  comboSignupFirstNameHint: "combo.signup.firstName.hint",
  comboSignupErrorTryAgainTitle: "combo.signup.error.tryAgainTitle",
  comboSignupErrorNoTerms: "combo.signup.error.noTerms",
  comboSignupEmailHint: "combo.signup.email.hint",
  comboSignupConfirmYourEmail: "combo.signup.confirmYourEmail",
  comboSignupBirthdayHint: "combo.signup.birthday.hint",
  comboSignUpTermsMissingAccept: "combo.sign.up.terms.missing.accept",
  comboSharedPriceAdditionsMissingUpdateProduct:
    "combo.shared.price.additions.missing.update.product",
  comboSharedPriceAdditionsMissingTitle:
    "combo.shared.price.additions.missing.title",
  comboSharedPriceAdditionsMissingSubtitle:
    "combo.shared.price.additions.missing.subtitle",
  comboSharedPriceAdditionsMissingAddProduct:
    "combo.shared.price.additions.missing.add.product",
  comboSendEmail: "combo.send.email",
  comboSearchPlaceholder: "combo.search.placeholder",
  comboSearchNoResult: "combo.search.no.result",
  comboRidersViewAllOrders: "combo.riders.viewAllOrders",
  comboRidersUnClaimingDelivery: "combo.riders.unClaimingDelivery",
  comboRidersTitle: "combo.riders.title",
  comboRidersStatus: "combo.riders.status",
  comboRidersStaffOnly: "combo.riders.staffOnly",
  comboRidersShowOrder: "combo.riders.showOrder",
  comboRidersScanToClaimOrder: "combo.riders.scanToClaimOrder",
  comboRidersScanClaimDeliverTitle: "combo.riders.scanClaimDeliver.title",
  comboRidersScanClaimDeliverDescription:
    "combo.riders.scanClaimDeliver.description",
  comboRidersPickUpAtRestaurant: "combo.riders.pickUpAtRestaurant",
  comboRidersPhoneNumber: "combo.riders.phoneNumber",
  comboRidersMyDeliveries: "combo.riders.myDeliveries",
  comboRidersMarkUnclaimed: "combo.riders.markUnclaimed",
  comboRidersMarkDelivered: "combo.riders.markDelivered",
  comboRidersDistance: "combo.riders.distance",
  comboRidersDeliveryUnclaimedSuccess: "combo.riders.deliveryUnclaimedSuccess",
  comboRidersDeliveryDelivered: "combo.riders.deliveryDelivered",
  comboRidersDeliveryClaimingFailed: "combo.riders.deliveryClaimingFailed",
  comboRidersDeliveryClaimed: "combo.riders.deliveryClaimed",
  comboRidersDeliveryAtCustomer: "combo.riders.deliveryAtCustomer",
  comboRidersDeliveringDelivery: "combo.riders.deliveringDelivery",
  comboRidersDeliveries: "combo.riders.deliveries",
  comboRidersCustomer: "combo.riders.customer",
  comboRidersClickToChooseShop: "combo.riders.clickToChooseShop",
  comboRidersClaimingDelivery: "combo.riders.claimingDelivery",
  comboRidersClaim: "combo.riders.claim",
  comboRewardsYourStatus: "combo.rewards.yourStatus",
  comboRewardsVoucherInfo: "combo.rewards.voucherInfo",
  comboRewardsVoucher: "combo.rewards.voucher",
  comboRewardsValidityYear: "combo.rewards.validity.year",
  comboRewardsValidityYearPlural: "combo.rewards.validity.year.plural",
  comboRewardsValidityMonth: "combo.rewards.validity.month",
  comboRewardsValidityMonthPlural: "combo.rewards.validity.month.plural",
  comboRewardsValidityDay: "combo.rewards.validity.day",
  comboRewardsValidityDayPlural: "combo.rewards.validity.day.plural",
  comboRewardsValidity: "combo.rewards.validity",
  comboRewardsUnlockingReward: "combo.rewards.unlockingReward",
  comboRewardsUnlockReward: "combo.rewards.unlockReward",
  comboRewardsTermsReadAndAccept: "combo.rewards.termsReadAndAccept",
  comboRewardsSubtitle: "combo.rewards.subtitle",
  comboRewardsStatus: "combo.rewards.status",
  comboRewardsSectionExpiredTitle: "combo.rewards.sectionExpiredTitle",
  comboRewardsSectionExpiredSubtitle: "combo.rewards.sectionExpiredSubtitle",
  comboRewardsSectionCompletedTitle: "combo.rewards.sectionCompletedTitle",
  comboRewardsSectionCompletedSubtitle:
    "combo.rewards.sectionCompletedSubtitle",
  comboRewardsRewardDetailsCompleteToReceive:
    "combo.rewards.rewardDetails.completeToReceive",
  comboRewardsRewardDetailsClaimed: "combo.rewards.rewardDetails.claimed",
  comboRewardsRewardTitle: "combo.rewards.reward.title",
  comboRewardsReward: "combo.rewards.reward",
  comboRewardsRemainingOrdersToComplete:
    "combo.rewards.remainingOrdersToComplete",
  comboRewardsReadyToBeClaimed: "combo.rewards.readyToBeClaimed",
  comboRewardsMarketingTerms: "combo.rewards.marketingTerms",
  comboRewardsInactive: "combo.rewards.inactive",
  comboRewardsGoalOrders: "combo.rewards.goalOrders",
  comboRewardsGoalOrdersPlural: "combo.rewards.goalOrders.plural",
  comboRewardsExpires: "combo.rewards.expires",
  comboRewardsExpired: "combo.rewards.expired",
  comboRewardsDialogJoinTitle: "combo.rewards.dialogJoinTitle",
  comboRewardsDialogJoinDescription: "combo.rewards.dialogJoinDescription",
  comboRewardsDialogJoinAccept: "combo.rewards.dialogJoinAccept",
  comboRewardsCongrats: "combo.rewards.congrats",
  comboRewardsCompletedGiftWaiting: "combo.rewards.completed.giftWaiting",
  comboRewardsCompleted: "combo.rewards.completed",
  comboRewardsClickHereToJoin: "combo.rewards.clickHereToJoin",
  comboRewardsClickBelowToUnlock: "combo.rewards.clickBelowToUnlock",
  comboRewardsClaimedRewardsDescription:
    "combo.rewards.claimedRewardsDescription",
  comboRewardsClaimedRewards: "combo.rewards.claimedRewards",
  comboRewardsClaimedCheckmark: "combo.rewards.claimedCheckmark",
  comboRewardsClaimed: "combo.rewards.claimed",
  comboRewardsChallenge: "combo.rewards.challenge",
  comboRewardsAddToWallet: "combo.rewards.addToWallet",
  comboRewardsActive: "combo.rewards.active",
  comboRewardsXXXcompleted: "combo.rewards.100completed",
  comboRestaurantOpenForOrders: "combo.restaurant.open.for.orders",
  comboRestaurantClosedForOrders: "combo.restaurant.closed.for.orders",
  comboRestaurant: "combo.restaurant",
  comboResetPasswordErrorMessage: "combo.resetPasswordError.message",
  comboResetPasswordTitle: "combo.resetPassword.title",
  comboResetPasswordSuccessDescription:
    "combo.resetPassword.successDescription",
  comboResetPasswordCheckEmail: "combo.resetPassword.checkEmail",
  comboReset: "combo.reset",
  comboReferralToptitle: "combo.referral.toptitle",
  comboReferralReadMore: "combo.referral.readMore",
  comboRecommendedProductsTitle: "combo.recommended.products.title",
  comboProfileVerifyPhone: "combo.profile.verifyPhone",
  comboProfileTerms: "combo.profile.terms",
  comboProfileSupportWeb: "combo.profile.support.web",
  comboProfileSupportEmail: "combo.profile.support.email",
  comboProfileSupport: "combo.profile.support",
  comboProfileSignout: "combo.profile.signout",
  comboProfileSeniority: "combo.profile.seniority",
  comboProfileSave: "combo.profile.save",
  comboProfileRiders: "combo.profile.riders",
  comboProfileRemoveCardAlertTitle: "combo.profile.removeCardAlertTitle",
  comboProfileRemoveCardAlertMessage: "combo.profile.removeCardAlertMessage",
  comboProfileRemoveCard: "combo.profile.removeCard",
  comboProfileRedirection: "combo.profile.redirection",
  comboProfilePoweredBy: "combo.profile.poweredBy",
  comboProfilePaymentCards: "combo.profile.paymentCards",
  comboProfileNoMemberCardsTitle: "combo.profile.noMemberCardsTitle",
  comboProfileNoMemberCardsMessage: "combo.profile.noMemberCardsMessage",
  comboProfileMyaddresses: "combo.profile.myaddresses",
  comboProfileMemberCards: "combo.profile.memberCards",
  comboProfileLegal: "combo.profile.legal",
  comboProfileHistory: "combo.profile.history",
  comboProfileHeapsgo: "combo.profile.heapsgo",
  comboProfileEnterPromoCode: "combo.profile.enterPromoCode",
  comboProfileDeleteprofile: "combo.profile.deleteprofile",
  comboProfileCreditCards: "combo.profile.creditCards",
  comboProfileChangesNotPossible: "combo.profile.changes.not.possible",
  comboProfileChangesAjour: "combo.profile.changes.ajour",
  comboProfileBuy: "combo.profile.buy",
  comboProfileAddCard: "combo.profile.addCard",
  comboProductAdditionsErrorTitle: "combo.product.additions.error.title",
  comboPickup: "combo.pickup",
  comboPickerToday: "combo.picker.today",
  comboPaymentZeroPaymentTitle: "combo.payment.zero.payment.title",
  comboPaymentVoucherSuccess: "combo.payment.voucher.success",
  comboPaymentVoucher: "combo.payment.voucher",
  comboPaymentRangescanning: "combo.payment.rangescanning",
  comboPaymentRangeinstructions: "combo.payment.rangeinstructions",
  comboPaymentPaymentconfirmed: "combo.payment.paymentconfirmed",
  comboPaymentPaymentConfirmed: "combo.payment.payment.confirmed",
  comboPaymentMethods: "combo.payment.methods",
  comboPaymentErrorPos_disconnectedHeader:
    "combo.payment.error.pos_disconnected.header",
  comboPaymentErrorPos_disconnectedBody:
    "combo.payment.error.pos_disconnected.body",
  comboPaymentErrorPayment_cancelledHeader:
    "combo.payment.error.payment_cancelled.header",
  comboPaymentErrorPayment_cancelledBody:
    "combo.payment.error.payment_cancelled.body",
  comboPaymentErrorNoconnectionHeader:
    "combo.payment.error.noconnection.header",
  comboPaymentErrorNo_connectionHeader:
    "combo.payment.error.no_connection.header",
  comboPaymentErrorNo_connectionBody: "combo.payment.error.no_connection.body",
  comboPaymentErrorMissing_payment_idHeader:
    "combo.payment.error.missing_payment_id.header",
  comboPaymentErrorMissing_payment_idBody:
    "combo.payment.error.missing_payment_id.body",
  comboPaymentErrorInsufficient_fundsHeader:
    "combo.payment.error.insufficient_funds.header",
  comboPaymentErrorInsufficient_fundsBody:
    "combo.payment.error.insufficient_funds.body",
  comboPaymentErrorInsufficientFunds: "combo.payment.error.insufficient.funds",
  comboPaymentErrorGenericHeader: "combo.payment.error.generic.header",
  comboPaymentErrorGenericBody: "combo.payment.error.generic.body",
  comboPaymentErrorDoNotHonor: "combo.payment.error.do.not.honor",
  comboPaymentErrorClosedHeader: "combo.payment.error.closed.header",
  comboPaymentErrorClosedBody: "combo.payment.error.closed.body",
  comboPaymentErrorCard_not_foundHeader:
    "combo.payment.error.card_not_found.header",
  comboPaymentErrorCard_not_foundBody:
    "combo.payment.error.card_not_found.body",
  comboPaymentErrorCardLost: "combo.payment.error.card.lost",
  comboPaymentErrorCardInvalidCvc: "combo.payment.error.card.invalid.cvc",
  comboPaymentErrorCardInvalid: "combo.payment.error.card.invalid",
  comboPaymentErrorCardExpired: "combo.payment.error.card.expired",
  comboPaymentEnterCodeDialogTitle: "combo.payment.enterCodeDialog.title",
  comboPaymentEnterCodeDialogMessage: "combo.payment.enterCodeDialog.message",
  comboPaymentEnterCode: "combo.payment.enterCode",
  comboPaymentDone: "combo.payment.done",
  comboPaymentClose: "combo.payment.close",
  comboPaymentCardconfirmed: "combo.payment.cardconfirmed",
  comboPaymentBoxFound: "combo.payment.boxFound",
  comboPaymentBartenderTitle: "combo.payment.bartender.title",
  comboPaymentBartenderSubtitle: "combo.payment.bartender.subtitle",
  comboPaymentBartenderSkipping: "combo.payment.bartender.skipping",
  comboPaymentBartenderConnectingError:
    "combo.payment.bartender.connecting.error",
  comboPaymentBartenderConnecting: "combo.payment.bartender.connecting",
  comboPayVenue: "combo.pay.venue",
  comboPaySubtitle: "combo.pay.subtitle",
  comboPaySecuredByStripe: "combo.pay.securedByStripe",
  comboPaySecureTitle: "combo.pay.secureTitle",
  comboPayPayingWith: "combo.pay.payingWith",
  comboPayPayingSubtitle: "combo.pay.paying.subtitle",
  comboPayPaying: "combo.pay.paying",
  comboPayPayAmount: "combo.pay.payAmount",
  comboPayExpires: "combo.pay.expires",
  comboPayCreditcardSubtext: "combo.pay.creditcard.subtext",
  comboPayChangePayment: "combo.pay.changePayment",
  comboPayCardPay: "combo.pay.cardPay",
  comboPayCardInfoClick: "combo.pay.cardInfoClick",
  comboPayBeep: "combo.pay.beep",
  comboPayAddMemberCard: "combo.pay.addMemberCard",
  comboPayAddCreditCardSuccess: "combo.pay.addCreditCard.success",
  comboPayAddCreditCardLoading: "combo.pay.addCreditCard.loading",
  comboPayAddCreditCardInviteCode: "combo.pay.addCreditCard.inviteCode",
  comboPayAddCreditCardDetails: "combo.pay.addCreditCard.details",
  comboPayAddCreditCardDescription: "combo.pay.addCreditCard.description",
  comboPayAddCreditCard: "combo.pay.addCreditCard",
  comboPasswordResetTokenNotFound: "combo.password.reset.token.notFound",
  comboPasswordResetTokenExpired: "combo.password.reset.token.expired",
  comboOrderUpsellTitle: "combo.order.upsell.title",
  comboOrderUpdateProduct: "combo.order.updateProduct",
  comboOrderUpdateOrder: "combo.order.updateOrder",
  comboOrderStatusSteptwo: "combo.order.status.steptwo",
  comboOrderStatusStepthree: "combo.order.status.stepthree",
  comboOrderStatusStepone: "combo.order.status.stepone",
  comboOrderStatusStepfour: "combo.order.status.stepfour",
  comboOrderStatusRejected: "combo.order.status.rejected",
  comboOrderStatusReady: "combo.order.status.ready",
  comboOrderStatusPickupTime: "combo.order.status.pickupTime",
  comboOrderStatusOrderRejectedTitle: "combo.order.status.orderRejectedTitle",
  comboOrderStatusOrderRejectedInfo: "combo.order.status.orderRejectedInfo",
  comboOrderStatusOrderRejectedDetails:
    "combo.order.status.orderRejectedDetails",
  comboOrderStatusOrderReceivedTitle: "combo.order.status.orderReceivedTitle",
  comboOrderStatusOrderReceivedInfo: "combo.order.status.orderReceivedInfo",
  comboOrderStatusOrderReceivedDetailsPickup:
    "combo.order.status.orderReceivedDetails.pickup",
  comboOrderStatusOrderReceivedDetailsDelivered:
    "combo.order.status.orderReceivedDetails.delivered",
  comboOrderStatusOrderReadyTitle: "combo.order.status.orderReadyTitle",
  comboOrderStatusOrderReadyDetails: "combo.order.status.orderReadyDetails",
  comboOrderStatusOrderInDeliveryDetails:
    "combo.order.status.orderInDeliveryDetails",
  comboOrderStatusOrderDeliveredTitle: "combo.order.status.orderDeliveredTitle",
  comboOrderStatusOrderDeliveredDetails:
    "combo.order.status.orderDeliveredDetails",
  comboOrderStatusOrderAcceptedInfoPickup:
    "combo.order.status.orderAcceptedInfo.pickup",
  comboOrderStatusOrderAcceptedInfoDelivery:
    "combo.order.status.orderAcceptedInfo.delivery",
  comboOrderStatusOrderAcceptedDetails:
    "combo.order.status.orderAcceptedDetails",
  comboOrderStatusDeliveryTime: "combo.order.status.deliveryTime",
  comboOrderStatusDelivery: "combo.order.status.delivery",
  comboOrderStatusDelivered: "combo.order.status.delivered",
  comboOrderStateReceived: "combo.order.state.received",
  comboOrderStateReady: "combo.order.state.ready",
  comboOrderStateNotPaid: "combo.order.state.not.paid",
  comboOrderStateInDelivery: "combo.order.state.in.delivery",
  comboOrderStateDeliveredPickup: "combo.order.state.delivered.pickup",
  comboOrderStateDeliveredDelivery: "combo.order.state.delivered.delivery",
  comboOrderStateAccepted: "combo.order.state.accepted",
  comboOrderSortClosest: "combo.order.sort.closest",
  comboOrderSortAlphabetically: "combo.order.sort.alphabetically",
  comboOrderSmileyReport: "combo.order.smileyReport",
  comboOrderRemove: "combo.order.remove",
  comboOrderQuantity: "combo.order.quantity",
  comboOrderProcessing: "combo.order.processing",
  comboOrderPickupTime: "combo.order.pickup.time",
  comboOrderPickupNotpossible: "combo.order.pickup.notpossible",
  comboOrderPickupLocation: "combo.order.pickup.location",
  comboOrderPickupFrom: "combo.order.pickup.from",
  comboOrderNoMoreTimeslotsTodayPickupTitle:
    "combo.order.noMoreTimeslotsTodayPickup.title",
  comboOrderNoMoreTimeslotsTodayDeliveryTitle:
    "combo.order.noMoreTimeslotsTodayDelivery.title",
  comboOrderNoMoreTimeslotsTodayTitle: "combo.order.noMoreTimeslotsToday.title",
  comboOrderNoMoreTimeslotsTodayMessage:
    "combo.order.noMoreTimeslotsToday.message",
  comboOrderNoMoreTimeslotsOnDatePickupTitle:
    "combo.order.noMoreTimeslotsOnDatePickup.title",
  comboOrderNoMoreTimeslotsOnDateDeliveryTitle:
    "combo.order.noMoreTimeslotsOnDateDelivery.title",
  comboOrderMoreInfo: "combo.order.moreInfo",
  comboOrderLoyaltyApplied: "combo.order.loyalty.applied",
  comboOrderGoToPayment: "combo.order.goToPayment",
  comboOrderGoBack: "combo.order.goBack",
  comboOrderDetailsTotalPaid: "combo.order.details.totalPaid",
  comboOrderDetailsTitleWhere: "combo.order.details.title.where",
  comboOrderDetailsTitleHow: "combo.order.details.title.how",
  comboOrderDetailsTitle: "combo.order.details.title",
  comboOrderDetailsSubtotal: "combo.order.details.subtotal",
  comboOrderDetailsPreorder: "combo.order.details.preorder",
  comboOrderDetailsPickupSubtext: "combo.order.details.pickup.subtext",
  comboOrderDetailsPickup: "combo.order.details.pickup",
  comboOrderDetailsNoTimeslotsForDayErrorMessage:
    "combo.order.details.no.timeslots.for.day.errorMessage",
  comboOrderDetailsEatIn: "combo.order.details.eatIn",
  comboOrderDetailsDeliverySubtext: "combo.order.details.delivery.subtext",
  comboOrderDetailsDeliveryChange: "combo.order.details.delivery.change",
  comboOrderDetailsDelivery: "combo.order.details.delivery",
  comboOrderDetailsAsap: "combo.order.details.asap",
  comboOrderDetails: "combo.order.details",
  comboOrderDeliveryComingSoon: "combo.order.deliveryComingSoon",
  comboOrderDeliveryWithDistance: "combo.order.delivery.withDistance",
  comboOrderDeliveryToobusy: "combo.order.delivery.toobusy",
  comboOrderDeliveryTooFarAway: "combo.order.delivery.tooFarAway",
  comboOrderDeliveryTo: "combo.order.delivery.to",
  comboOrderDeliveryTime: "combo.order.delivery.time",
  comboOrderDeliverySecond: "combo.order.delivery.second",
  comboOrderDeliveryNotpossibleToAddress:
    "combo.order.delivery.notpossibleToAddress",
  comboOrderDeliveryNotpossibleBody: "combo.order.delivery.notpossibleBody",
  comboOrderDeliveryNotpossible: "combo.order.delivery.notpossible",
  comboOrderDeliveryLocation: "combo.order.delivery.location",
  comboOrderDeliveryFirst: "combo.order.delivery.first",
  comboOrderDeliveryChooseAddress: "combo.order.delivery.chooseAddress",
  comboOrderDeliveryChange: "combo.order.delivery.change",
  comboOrderDeliveryAddressOutsideRange:
    "combo.order.delivery.addressOutsideRange",
  comboOrderDeliveryAddressTo: "combo.order.delivery.address.to",
  comboOrderDeliveryAddressChange: "combo.order.delivery.address.change",
  comboOrderCustomEstimateConfirmationOnEmail:
    "combo.order.customEstimate.confirmationOnEmail",
  comboOrderCopyCta: "combo.order.copy.cta",
  comboOrderCopy: "combo.order.copy",
  comboOrderConfirmation: "combo.order.confirmation",
  comboOrderClickToPreOrder: "combo.order.clickToPreOrder",
  comboOrderClickToOrderAsap: "combo.order.clickToOrderAsap",
  comboOrderChooseSubtextMadklubben: "combo.order.choose.subtext.madklubben",
  comboOrderChooseSubtext: "combo.order.choose.subtext",
  comboOrderChooseSubtextPlural: "combo.order.choose.subtext.plural",
  comboOrderChoosePickup: "combo.order.choose.pickup",
  comboOrderChooseDelivery: "combo.order.choose.delivery",
  comboOrderChoose: "combo.order.choose",
  comboOrderCheckoutVoucherNotEligibleTemplateTitle:
    "combo.order.checkout.voucherNotEligibleTemplate.title",
  comboOrderCheckoutVoucherNotEligibleTitle:
    "combo.order.checkout.voucherNotEligible.title",
  comboOrderCheckoutVoucherNotEligible:
    "combo.order.checkout.voucherNotEligible",
  comboOrderCheckoutViewAll: "combo.order.checkout.viewAll",
  comboOrderCheckoutTotal: "combo.order.checkout.total",
  comboOrderCheckoutTitle: "combo.order.checkout.title",
  comboOrderCheckoutSumup: "combo.order.checkout.sumup",
  comboOrderCheckoutSubtotal: "combo.order.checkout.subtotal",
  comboOrderCheckoutRequestTimedOut: "combo.order.checkout.requestTimedOut",
  comboOrderCheckoutRemoveBasketItemRemove:
    "combo.order.checkout.removeBasketItemRemove",
  comboOrderCheckoutRemoveBasketItemHeader:
    "combo.order.checkout.removeBasketItemHeader",
  comboOrderCheckoutRemoveBasketItemBody:
    "combo.order.checkout.removeBasketItemBody",
  comboOrderCheckoutProductsTitle: "combo.order.checkout.products.title",
  comboOrderCheckoutProductNotAvailable:
    "combo.order.checkout.productNotAvailable",
  comboOrderCheckoutPaymentTotal: "combo.order.checkout.payment.total",
  comboOrderCheckoutPaymentTitle: "combo.order.checkout.payment.title",
  comboOrderCheckoutPaymentAdd: "combo.order.checkout.payment.add",
  comboOrderCheckoutOutsideOpeningHoursWithDate:
    "combo.order.checkout.outsideOpeningHoursWithDate",
  comboOrderCheckoutOutsideOpeningHoursTitle:
    "combo.order.checkout.outsideOpeningHoursTitle",
  comboOrderCheckoutOutsideOpeningHours:
    "combo.order.checkout.outsideOpeningHours",
  comboOrderCheckoutMinimumPriceNotMet:
    "combo.order.checkout.minimumPriceNotMet",
  comboOrderCheckoutMinDeliveryMessage:
    "combo.order.checkout.min.delivery.message",
  comboOrderCheckoutLoyaltyTitle: "combo.order.checkout.loyalty.title",
  comboOrderCheckoutLoyaltyAddSubtext:
    "combo.order.checkout.loyalty.add.subtext",
  comboOrderCheckoutLoyaltyAdd: "combo.order.checkout.loyalty.add",
  comboOrderCheckoutDeliveryMinimumPriceNotMetTitle:
    "combo.order.checkout.deliveryMinimumPriceNotMet.title",
  comboOrderCheckoutDeliveryMinimumPriceNotMetDetails:
    "combo.order.checkout.deliveryMinimumPriceNotMet.details",
  comboOrderCheckoutDeliveryMinimumPriceNotMetDescription:
    "combo.order.checkout.deliveryMinimumPriceNotMet.description",
  comboOrderCheckoutDeliveryExtraFeeDetails:
    "combo.order.checkout.deliveryExtraFeeDetails",
  comboOrderCheckoutDeliveryExtraFee: "combo.order.checkout.deliveryExtraFee",
  comboOrderCheckoutComment: "combo.order.checkout.comment",
  comboOrderCheckoutClosedForOrders: "combo.order.checkout.closedForOrders",
  comboOrderCheckoutAddDiscount: "combo.order.checkout.addDiscount",
  comboOrderCheckout: "combo.order.checkout",
  comboOrderCheckAdditions: "combo.order.checkAdditions",
  comboOrderCartEmpty: "combo.order.cart.empty",
  comboOrderCartChooseAdditions: "combo.order.cart.chooseAdditions",
  comboOrderCancelYes: "combo.order.cancel.yes",
  comboOrderCancelTitle: "combo.order.cancel.title",
  comboOrderCancelStay: "combo.order.cancel.stay",
  comboOrderCancelMessage: "combo.order.cancel.message",
  comboOrderAllergens: "combo.order.allergens",
  comboOrderAdditionsSubtext: "combo.order.additions.subtext",
  comboOrderAdditionsSome: "combo.order.additions.some",
  comboOrderAdditionsNoneSelected: "combo.order.additions.noneSelected",
  comboOrderAdditionsNone: "combo.order.additions.none",
  comboOrderAdditionsInfoMin: "combo.order.additions.info.min",
  comboOrderAdditionsInfoMaxreached: "combo.order.additions.info.maxreached",
  comboOrderAdditionsInfoMaxMore: "combo.order.additions.info.max.more",
  comboOrderAdditionsInfoMax: "combo.order.additions.info.max",
  comboOrderAdditions: "combo.order.additions",
  comboOrderAddcommentTitle: "combo.order.addcomment.title",
  comboOrderAddcommentSubtitle: "combo.order.addcomment.subtitle",
  comboOrderAddcomment: "combo.order.addcomment",
  comboOrderAddProduct: "combo.order.addProduct",
  comboOrderActiveOrders: "combo.order.active.orders",
  comboOrderActiveOrdersPlural: "combo.order.active.orders.plural",
  comboOpeninghours: "combo.openinghours",
  comboOpeningHoursOn: "combo.opening.hours.on",
  comboOnboardingSkip: "combo.onboarding.skip",
  comboNutrition: "combo.nutrition",
  comboNotLoggedInTitle: "combo.not.logged.in.title",
  comboNotLoggedInDescription: "combo.not.logged.in.description",
  comboNoMoreTimeslotsTitle: "combo.no.more.timeslots.title",
  comboNoMoreTimeslotsSubtitle: "combo.no.more.timeslots.subtitle",
  comboNoBenefitsAvailable: "combo.no.benefits.available",
  comboMissing: "combo.missing",
  comboMenuRewards: "combo.menu.rewards",
  comboMenuOrder: "combo.menu.order",
  comboMenuMe: "combo.menu.me",
  comboMenuHome: "combo.menu.home",
  comboMenuCards: "combo.menu.cards",
  comboMembershipTermsReadAndAccept: "combo.membership.terms.readAndAccept",
  comboMembershipTermsMarketing: "combo.membership.terms.marketing",
  comboMembershipSignupReferralCodeTitleSubtext:
    "combo.membership.signup.referral.code.title.subtext",
  comboMembershipSignupReferralCodeTitle:
    "combo.membership.signup.referral.code.title",
  comboMembershipSignupReferralCodeSuccessTitle:
    "combo.membership.signup.referral.code.success.title",
  comboMembershipSignupReferralCodeSuccessSubtext:
    "combo.membership.signup.referral.code.success.subtext",
  comboMembershipSignupReferralCodeSuccess:
    "combo.membership.signup.referral.code.success",
  comboMembershipSignupReferralCodeSubmit:
    "combo.membership.signup.referral.code.submit",
  comboMembershipSignupReferralCodeDismiss:
    "combo.membership.signup.referral.code.dismiss",
  comboMembershipSignupReferralCodeConfirmationSubtitle:
    "combo.membership.signup.referral.code.confirmationSubtitle",
  comboMembershipSignupReferralCodeConfirmation:
    "combo.membership.signup.referral.code.confirmation",
  comboMembershipSignupAddcreditcard: "combo.membership.signup.addcreditcard",
  comboMarketing: "combo.marketing",
  comboManage: "combo.manage",
  comboLoyaltyGeneralCodePlaceholder: "combo.loyalty.general.code.placeholder",
  comboLoyaltyBenefitCurrencyMismatch:
    "combo.loyalty.benefit.currency.mismatch",
  comboLoyaltyBenefitAddedToWalletTip:
    "combo.loyalty.benefit.added.to.wallet.tip",
  comboLoyaltyBenefitAddedToWalletSubtitle:
    "combo.loyalty.benefit.added.to.wallet.subtitle",
  comboLoyaltyBenefitAddedToWallet: "combo.loyalty.benefit.added.to.wallet",
  comboLoyaltyBenefitAddedToOrderTitle:
    "combo.loyalty.benefit.added.to.order.title",
  comboLoyaltyBenefitAddedToOrderSubtitle:
    "combo.loyalty.benefit.added.to.order.subtitle",
  comboLoginPasswordHint: "combo.login.password.hint",
  comboLoginErrortitle: "combo.login.errortitle",
  comboLoginErrormessage: "combo.login.errormessage",
  comboLoginErrordismiss: "combo.login.errordismiss",
  comboInputsNamePlaceholder: "combo.inputs.name.placeholder",
  comboInputsNameLabel: "combo.inputs.name.label",
  comboInputsNameError: "combo.inputs.name.error",
  comboInputsFavoriteRestaurantPlaceholder:
    "combo.inputs.favorite.restaurant.placeholder",
  comboInputsFavoriteRestaurantLabel: "combo.inputs.favorite.restaurant.label",
  comboInputsFavoriteRestaurantError: "combo.inputs.favorite.restaurant.error",
  comboInputsFamilyMembersError: "combo.inputs.family.members.error",
  comboInputsBirthdayPlaceholder: "combo.inputs.birthday.placeholder",
  comboInputsBirthdayLabel: "combo.inputs.birthday.label",
  comboInputsBirthdayError: "combo.inputs.birthday.error",
  comboIngredients: "combo.ingredients",
  comboHowManyDoYouWant: "combo.how.many.do.you.want",
  comboHomeOfferClickToBuy: "combo.home.offer.clickToBuy",
  comboHomeOffer: "combo.home.offer",
  comboHomeMemberBenefit: "combo.home.memberBenefit",
  comboGoToRestaurants: "combo.go.to.restaurants",
  comboGeneralErrorMessage: "combo.general.error.message",
  comboFormsDidYouMean: "combo.forms.did.you.mean",
  comboFiltersTo: "combo.filters.to",
  comboFiltersResults: "combo.filters.results",
  comboFiltersPrice: "combo.filters.price",
  comboFiltersLabels: "combo.filters.labels",
  comboFiltersFrom: "combo.filters.from",
  comboFiltersClearFilter: "combo.filters.clear.filter",
  comboFilterFilter: "combo.filter.filter",
  comboErrorLocation_permissionBody: "combo.error.location_permission.body",
  comboErrorBluetoothPermissionBody: "combo.error.bluetooth.permission.body",
  comboEditDetailsSearchLocation: "combo.edit.details.search.location",
  comboEditDetailsSearchAddressMapTitle:
    "combo.edit.details.search.address.map.title",
  comboEditDetailsSearchAddressMapDescription:
    "combo.edit.details.search.address.map.description",
  comboEditDetailsSearchAddressCurrentDescription:
    "combo.edit.details.search.address.current.description",
  comboEditDetailsGuide: "combo.edit.details.guide",
  comboEditDetailsChooseLocationOnMap:
    "combo.edit.details.choose.locationOnMap",
  comboEditDetailsChooseLocation: "combo.edit.details.choose.location",
  comboEditDetailsAddressTitle: "combo.edit.details.address.title",
  comboEditDetailsAddressSubtitle: "combo.edit.details.address.subtitle",
  comboEditDetailsAddressNameSubtitle:
    "combo.edit.details.address.name.subtitle",
  comboEditDetailsAddressNameHint: "combo.edit.details.address.name.hint",
  comboEditDetailsAddressName: "combo.edit.details.address.name",
  comboEditDetailsAddressMissingPostcode:
    "combo.edit.details.address.missingPostcode",
  comboEditDetailsAddressMissingCity: "combo.edit.details.address.missingCity",
  comboEditDetailsAddressInstructionsSubtitle:
    "combo.edit.details.address.instructions.subtitle",
  comboEditDetailsAddressInstructions:
    "combo.edit.details.address.instructions",
  comboEditDetailsAddressInfoTitle: "combo.edit.details.address.info.title",
  comboEditDetailsAddressHint: "combo.edit.details.address.hint",
  comboEditDetailsAddressGeneralError:
    "combo.edit.details.address.generalError",
  comboEditDetailsAddressEdit: "combo.edit.details.address.edit",
  comboEditDetailsAddressDelete: "combo.edit.details.address.delete",
  comboEditDetailsAddress: "combo.edit.details.address",
  comboEditDetailsAdditionalInfoSubtitle:
    "combo.edit.details.additional.info.subtitle",
  comboEditDetailsAdditionalInfoHint: "combo.edit.details.additional.info.hint",
  comboEditDetails: "combo.edit.details",
  comboDownloadAppCta: "combo.download.app.cta",
  comboDetailsDescriptionReadMore: "combo.details.description.readMore",
  comboDepositTopuptitle: "combo.deposit.topuptitle",
  comboDepositTopupsubtitleThird: "combo.deposit.topupsubtitle.third",
  comboDepositTopupsubtitleSecond: "combo.deposit.topupsubtitle.second",
  comboDepositTopupsubtitle: "combo.deposit.topupsubtitle",
  comboDepositSuccessTitle: "combo.deposit.successTitle",
  comboDepositErrorNoMoneyTitle: "combo.deposit.error.noMoney.title",
  comboDepositErrorNoMoneyMessage: "combo.deposit.error.noMoney.message",
  comboDepositErrorNoCardSelectedTitle:
    "combo.deposit.error.noCardSelectedTitle",
  comboDepositErrorNoCardSelectedMessage:
    "combo.deposit.error.noCardSelectedMessage",
  comboDepositErrorLimitReachedTitle: "combo.deposit.error.limitReached.title",
  comboDepositErrorLimitReachedMessage:
    "combo.deposit.error.limitReached.message",
  comboDepositErrorChargeTitle: "combo.deposit.error.charge.title",
  comboDepositErrorChargeMessage: "combo.deposit.error.charge.message",
  comboDeliveryDetailsChooseaddress: "combo.delivery.details.chooseaddress",
  comboDeliveryDetailsAddress: "combo.delivery.details.address",
  comboDeliveryDetails: "combo.delivery.details",
  comboDelivery: "combo.delivery",
  comboCreateaccountVerifyEmailDetails:
    "combo.createaccount.verifyEmailDetails",
  comboCreateaccountVerifyEmail: "combo.createaccount.verifyEmail",
  comboCreateaccountStaffCardTitle: "combo.createaccount.staffCardTitle",
  comboCreateaccountStaffCardFieldTitle:
    "combo.createaccount.staffCardFieldTitle",
  comboCreateaccountShow: "combo.createaccount.show",
  comboCreateaccountResendEmail: "combo.createaccount.resendEmail",
  comboCreateaccountPhoneValidation: "combo.createaccount.phoneValidation",
  comboCreateaccountPhoneSubtext: "combo.createaccount.phone.subtext",
  comboCreateaccountPhone: "combo.createaccount.phone",
  comboCreateaccountPasswordValidation:
    "combo.createaccount.passwordValidation",
  comboCreateaccountPassword: "combo.createaccount.password",
  comboCreateaccountLast: "combo.createaccount.last",
  comboCreateaccountHide: "combo.createaccount.hide",
  comboCreateaccountGetStartedTitle: "combo.createaccount.getStarted.title",
  comboCreateaccountGetStarted: "combo.createaccount.getStarted",
  comboCreateaccountFirst: "combo.createaccount.first",
  comboCreateaccountExample: "combo.createaccount.example",
  comboCreateaccountEmptyValidation: "combo.createaccount.emptyValidation",
  comboCreateaccountEmailValidation: "combo.createaccount.emailValidation",
  comboCreateaccountEmailSubtext: "combo.createaccount.email.subtext",
  comboCreateaccountEmail: "combo.createaccount.email",
  comboCreateaccountChatWithSupport: "combo.createaccount.chatWithSupport",
  comboCreateaccountBithdayValidation: "combo.createaccount.bithdayValidation",
  comboCreateaccountBirthday: "combo.createaccount.birthday",
  comboCookiesPolicy: "combo.cookies.policy",
  comboCookiesNecessary: "combo.cookies.necessary",
  comboCookiesInsuranceText: "combo.cookies.insurance.text",
  comboCookiesDescription: "combo.cookies.description",
  comboContinueOrder: "combo.continue.order",
  comboCodeVoucherExpired: "combo.code.voucher.expired",
  comboCodeTitle: "combo.code.title",
  comboCodeSuccessTitle: "combo.code.success.title",
  comboCodeSuccessTitlePlural: "combo.code.success.title.plural",
  comboCodeSuccessSubtitle: "combo.code.success.subtitle",
  comboCodeSuccessSubtitlePlural: "combo.code.success.subtitle.plural",
  comboCodeSuccessGiftcardvoucherTitle:
    "combo.code.success.giftcardvoucher.title",
  comboCodeSuccessGiftcardvoucherTitlePlural:
    "combo.code.success.giftcardvoucher.title.plural",
  comboCodeSuccessGiftcardTitle: "combo.code.success.giftcard.title",
  comboCodeSuccessGiftcardSubtitle: "combo.code.success.giftcard.subtitle",
  comboCodeSubtitle: "combo.code.subtitle",
  comboCodeFailedSubtext: "combo.code.failed.subtext",
  comboChooseTimeToContinue: "combo.choose.time.to.continue",
  comboChooseTime: "combo.choose.time",
  comboChildren: "combo.children",
  comboCheckoutYourDetailsPhoneError: "combo.checkout.yourDetails.phoneError",
  comboCheckoutYourDetailsOnlyLettersAllowed:
    "combo.checkout.yourDetails.onlyLettersAllowed",
  comboCheckoutYourDetailsLastNameError:
    "combo.checkout.yourDetails.lastNameError",
  comboCheckoutYourDetailsFirstNameError:
    "combo.checkout.yourDetails.firstNameError",
  comboCheckoutYourDetailsEmailErrorValidate:
    "combo.checkout.yourDetails.emailErrorValidate",
  comboCheckoutYourDetailsEmailError: "combo.checkout.yourDetails.emailError",
  comboCheckoutYourDetails: "combo.checkout.yourDetails",
  comboCheckoutTooBusy: "combo.checkout.tooBusy",
  comboCheckoutProductsUnavailableTitle:
    "combo.checkout.products.unavailable.title",
  comboCheckoutProductsUnavailableSubtitle:
    "combo.checkout.products.unavailable.subtitle",
  comboCheckoutPreparingPayment: "combo.checkout.preparingPayment",
  comboCheckoutPaymentInProgress: "combo.checkout.paymentInProgress",
  comboCheckoutPaymentTitle: "combo.checkout.payment.title",
  comboCheckoutPaymentMessage: "combo.checkout.payment.message",
  comboCheckoutMyBenefitsTitle: "combo.checkout.my.benefits.title",
  comboCateringAndEvents: "combo.catering.and.events",
  comboCartsTitle: "combo.carts.title",
  comboCartsEmptyTitle: "combo.carts.empty.title",
  comboCartsEmptySubtitle: "combo.carts.empty.subtitle",
  comboCartShowOrder: "combo.cart.showOrder",
  comboCartProductsRemovedTitle: "combo.cart.products.removed.title",
  comboCartProductsRemovedSubtitle: "combo.cart.products.removed.subtitle",
  comboCardRetryIn: "combo.card.retryIn",
  comboCardPayWithDiscount: "combo.card.payWithDiscount",
  comboBuyVouchersSuccess: "combo.buy.vouchers.success",
  comboBuyVouchersPaymentMethodMissingTitle:
    "combo.buy.vouchers.paymentMethodMissing.title",
  comboBuyVouchersPaymentMethodMissingDescription:
    "combo.buy.vouchers.paymentMethodMissing.description",
  comboBuyVouchersFailedSubtext: "combo.buy.vouchers.failed.subtext",
  comboBuyVouchersFailed: "combo.buy.vouchers.failed",
  comboBuyVouchersCoolDownReached: "combo.buy.vouchers.coolDownReached",
  comboBuyVouchersCoolDownLimitedReached:
    "combo.buy.vouchers.coolDownLimitedReached",
  comboBuyVouchersCoolDownAmountLeft: "combo.buy.vouchers.coolDownAmountLeft",
  comboBuyVouchersConfirmedSubtitle: "combo.buy.vouchers.confirmed.subtitle",
  comboBuyVouchersConfirmed: "combo.buy.vouchers.confirmed",
  comboBuyVouchers: "combo.buy.vouchers",
  comboBonesOnlyInputsShowFamilyBirthdaysLabel:
    "combo.bones.only.inputs.show.family.birthdays.label",
  comboBluetoothTitle: "combo.bluetooth.title",
  comboBluetoothMessage: "combo.bluetooth.message",
  comboBeaconErrorConnection_closedHeader:
    "combo.beacon.error.connection_closed.header",
  comboBeaconErrorConnection_closedBody:
    "combo.beacon.error.connection_closed.body",
  comboBeaconErrorBeen_in_backgroundHeader:
    "combo.beacon.error.been_in_background.header",
  comboBeaconErrorBeen_in_backgroundBody:
    "combo.beacon.error.been_in_background.body",
  comboAnalytics: "combo.analytics",
  comboAdults: "combo.adults",
  comboAddressesChange: "combo.addresses.change",
  comboAdditionGroupSharedPriceDescriptionPriced:
    "combo.addition.group.shared.price.description.priced",
  comboAdditionGroupSharedPriceDescriptionPricedPlural:
    "combo.addition.group.shared.price.description.priced.plural",
  comboAdditionGroupSharedPriceDescriptionFree:
    "combo.addition.group.shared.price.description.free",
  comboAdditionGroupSharedPriceDescriptionFreePlural:
    "combo.addition.group.shared.price.description.free.plural",
  comboAddingCardTitle: "combo.adding.card.title",
  comboAddingCardSubtitle: "combo.adding.card.subtitle",
  comboAddChild: "combo.add.child",
  comboAddCardDescription: "combo.add.card.description",
  comboAddAdult: "combo.add.adult",
  comboActivityOverview: "combo.activity.overview",
  comboActivityEmpty: "combo.activity.empty",
  comboActivityDetails: "combo.activity.details",
  comboAccept: "combo.accept",
  closedTodayInfoboxHeader: "closed.today.infobox.header",
  closedInfoboxHeader: "closed.infobox.header",
  closedFutureInfoboxHeader: "closed.future.infobox.header",
  cateringRequestCateringOrderConfirm:
    "catering.request.catering.order.confirm",
  cateringRequestCateringOrder: "catering.request.catering.order",
  cateringOrderSuccessSubtitleObs: "catering.order.success.subtitle.obs",
  cateringOrderSuccessSubtitle: "catering.order.success.subtitle",
  cartTitleProducts: "cart.title.products",
  cartTitleMain: "cart.title.main",
  cartButtonClear: "cart.button.clear",
  capacityControlErrorSelectedTimeslotNotAvailable:
    "capacityControl.error.selectedTimeslotNotAvailable",
  capacityControlErrorNoTimeslotsAvailable:
    "capacityControl.error.noTimeslotsAvailable",
  capacityControlErrorMaxUnitsReached: "capacityControl.error.maxUnitsReached",
  capacityControlErrorMaxCapacityReached:
    "capacityControl.error.maxCapacityReached",
  buzzRidersTitle: "buzz.riders.title",
  buzzRidersDescription: "buzz.riders.description",
  bonesCustomYourOrder: "bones.custom.your.order",
  bonesCustomUpsellsubTitle: "bones.custom.upsellsub.title",
  bonesCustomUpsellTitle: "bones.custom.upsell.title",
  bonesCustomUpsellPanelItemTitle: "bones.custom.upsell.panel.item.title",
  bonesCustomTotal: "bones.custom.total",
  bonesCustomTermsSuffix: "bones.custom.terms.suffix",
  bonesCustomTermsPrefix: "bones.custom.terms.prefix",
  bonesCustomStartTitle: "bones.custom.start.title",
  bonesCustomQuestionaire: "bones.custom.questionaire",
  bonesCustomQuantityTitle: "bones.custom.quantity.title",
  bonesCustomPlaceOrder: "bones.custom.place.order",
  bonesCustomPickupLocation: "bones.custom.pickup.location",
  bonesCustomOrderDetailsTitle: "bones.custom.order.details.title",
  bonesCustomOpeningHours: "bones.custom.opening.hours",
  bonesCustomContinueToCheckoutTitle: "bones.custom.continue.to.checkout.title",
  bonesCustomContinueToCheckoutSubtitle:
    "bones.custom.continue.to.checkout.subtitle",
  bonesCustomContinueShopping: "bones.custom.continue.shopping",
  bonesCustomContactInfo: "bones.custom.contact.info",
  bonesCustomComment: "bones.custom.comment",
  bonesCustomChooseOptions: "bones.custom.choose.options",
  bonesCustomCheckoutTitle: "bones.custom.checkout.title",
  bonesCustomCartTitle: "bones.custom.cart.title",
  bonesCustomAddToCart: "bones.custom.add.to.cart",
  asapNotAvailableSubtitle: "asap.not.available.subtitle",
  addressTooFarAwayWebSubtitle: "address.too.far.away.web.subtitle",
  addressTooFarAway: "address.too.far.away",
}
